class tlAdvancedFreeGift {
    LOCAL_STORAGE = "tl-advanced-free-gift-local-storage";
    PROXY_URL = "apps/salepify";
    PROPERTY = "_salepify-advanced-fg"
    API_VERSION = "2024-04"
    POPUP_ANIMATION = {
        FADE_IN: "fade_in",
        SLIDE_IN_UP: "slide_in_up",
        SLIDE_IN_DOWN: "slide_in_down",
        SLIDE_IN_LEFT: "slide_in_left",
        SLIDE_IN_RIGHT: "slide_in_right",
        ZOOM_IN: "zoom_in"
    }

    POSITION_OF_POPUP = {
        BOTTOM_RIGHT: 'bottom-right',
        BOTTOM_LEFT: 'bottom-left',
        CENTER_LEFT: 'center-left',
        CENTER_RIGHT: 'center-right'
    }

    APPLY_TO_PRODUCT = {
        ALL: "all",
        COLLECTION: "collection",
        PRODUCT: "product",
        VARIANT: "variant",
        TAG: "tag"
    }

    COUNTRY_TARGET_TYPE = {
        INCLUDE: "include",
        EXCLUDE: "exclude"
    }

    APPLY_CONDITION_TYPE = {
        AMOUNT: "amount",
        QUANTITY: "quantity",
        ALL:"all"
    }

    CUSTOMER_TARGET = {
        ALL: "all",
        NOT_LOGGED: "not_logged",
        LOGGED_IN: "logged_in",
        CUSTOMER_TAG: "customer_tag",
        SPECIFIC_CUSTOMER: "specific_customer",
        ORDER_COUNT: "order_count",
        TOTAL_SPENT: "total_spent"
    }

    SHOW_ON_PAGES = {
        ALL: "all",
        PRODUCT: "product_page",
        HOME: "home_page",
        COLLECTION: "collection_page",
        CART: "cart_page",
        SPECIFIC: "specific_page"
    }

    CONDITION_STATE = {
        NOT_MET: "not_met",
        MET_BEFORE_CLAIM: "met_before_claim",
        MET_AFFTER_CLAIM: "met_after_claim"
    }

    AUTO_ADD_TYPE = {
        FIRST_AVAILABLE: "first_available",
        SELECT_TO_ADD: "select_to_add"
    }

    GIFT_TYPE ={
        VARIANT: "variant",
        SAME_BUY: "same_buy"
    }

    ADVANCED_CONDITION = {
        SPECIFIC_COUNTRY: "specific_country",
        CUSTOMER_TAG: "customer_tag",
        SPECIFIC_CUSTOMER: "specific_customer",
        CUSTOMER_STATUS: "customer_status",
        ORDER_COUNT: "order_count",
        TOTAL_SPENT: "total_spent"
    }

    CUSTOMER_STATUS = {
        NOT_LOGGED: "not_logged",
        LOGGED_IN: "logged_in"
    }

    DISPLAY_SETTING = {
        background_section: {
            background_color: "#FFFFFF",
            close_btn_color: "#9CA3AF",
            color: "#000000",
            header_title: {
                font_size: 20,
                font_family: "inherit",
            },
        },
        main_section: {
            offer_title: {
                color: "#000000",
                font_size: 16,
                font_family: "inherit",
            },
            upsell_msg: {
                font_size: 16,
                font_family: "inherit",
                color: "#FFFFFF",
                background_color: "#4F46E5",
                padding: 12,
            },
            border: {
                border_color: "#D1D5DB",
                border_width: 1,
                border_radius: 8
            }
        },
        detail_section: {
            gift_item: {
                free_text_color: "#059669",
                product_text_color: "#000000",
                price_text_color: "#6B7280"
            },
            selected_text: {
                color: "#4F46E5",
            },
            gift_selector: {
                color: "#4F46E5"
            },
        },
        claim_btn: {
            font_size: 16,
            font_weight: 600,
            font_family: "inherit",
            color: "#FFFFFF",
            background_color: "#4F46E5",
            padding: 9
        },
        icon_popup: {
            is_icon_displayed: true,
            color: "#000000",
            icon_color: "#8614dd",
            icon_size: 65,
            background_color: "#FFFFFF",
            border_color: "#FFFFFF",
            border_radius: 35,
            border_width: 0,
            adv_free_gift_image: null,
        },
        animation: this.POPUP_ANIMATION.FADE_IN,
        position: this.POSITION_OF_POPUP.BOTTOM_RIGHT
    }

    DEFAULT_TRANSLATION = {
        header: {
            title: "Claim these awesome free gifts",
            subtitle: "Shop now before they're gone"
        },
        main_offer : {
            eligible_offer_title: "Congratulations! You’ve received a free gift",
            view_more: "View more",
            view_less: "View less"
        },
        upsell_msg: {
            not_meet_condition: "Buy {{remain}} more to choose gift",
            meet_condition: "You can select {{gift_number}} gift",
            claimed: "You claimed all gifts",
            for_auto_add: "You’ll receive {{gift_number}} gifts"
        },
        product_detail: {
            free_text_content: "Free",
        },
        manual_choose_gift: {
            selected_text: "Selected",
            claim_btn: "Claim",
            claimed_btn: "Claimed",
            choose_enough_gift: "You've chosen enough gifts."
        },
        gift_icon: {
            manual: "Please claim your gift.",
            auto: "You have just received a gift."
        }
    }

    #storeAccessToken

    constructor(
        template,
        currencySymbol,
        defaultImg,
        offerImg,
        updateState, 
        displaySettings,
        currentProductId,
        collectionOfProduct,
        productIdMapCollection,
        currentProductVariantIds,
        currentCustomer,
        translation
    ) {
        // Element
        this.iconPopupElement = document.querySelector(".salepify-fg-advanced-icon-popup");
        this.iconPopupBadgeElement = document.querySelector(".salepify-fg-advanced-icon-popup-badge");
        this.iconPopupBadgeTextElement = document.querySelector(".salepify-fg-advanced-icon-popup-badge__text");


        this.cartId = "";
        this.itemsInCart = new Map();
        //Data item in temp cart
        this.itemsInTempCart = new Map();
        this.giftsInTempCart = new Map();

        this.updateState = updateState ? updateState.advanced_free_gift : null;
        this.currentProductId = currentProductId;
        this.collectionOfProduct = collectionOfProduct;
        this.productIdMapCollection = new Map(productIdMapCollection);
        this.currentProductVariantIds = currentProductVariantIds;
        this.currentCustomer = currentCustomer;

        this.ruleIdMapData = new Map();

        // Store the id and price of list customer buy in cart
        this.ruleIdMapParentInCart = new Map();
        // Store the quantity of selected gift
        this.ruleIdMapSelectedGift = new Map();
        this.ruleIdMapGiftQtyInCart = new Map();
        this.ruleIdMapGiftAddedByApp = new Map();

        this.ruleIdMapCanClaimTime = new Map();

        this.ruleIdMapTimeoutErr = new Map();

        // Data
        this.shopifyIdMapData = new Map();

        //Template
        this.template = template;
        this.defaultImg = defaultImg;
        this.offerImg = offerImg;
        // Currency
        this.currency = currencySymbol;
        this.currencyRate = 1;
        if (Shopify && Shopify.currency) {
            this.currency = Shopify.currency.active;
            this.currencyRate = Number(Shopify.currency.rate);
        }

        // Get display setting data
        this.displaySettings = displaySettings ? this.deepMergeObject(
            this.DISPLAY_SETTING, 
            displaySettings.popup_new ? displaySettings.popup_new : displaySettings.advanced_free_gift
        ) : this.DISPLAY_SETTING;

        // Get translation data
        let customTranslation = null;
        if(translation){
            const locale = Shopify?.locale || "en";
            customTranslation = translation.popup_new[locale] ? translation.popup_new[locale] : null;
        }else if(displaySettings && displaySettings.advanced_free_gift){
            const oldTranslation = displaySettings.advanced_free_gift;
            customTranslation = {
                header: {
                    title: oldTranslation.background_section.title,
                    subtitle: oldTranslation.background_section.subtitle
                },
                main_offer : {
                    eligible_offer_title: "Congratulations! You’ve received a free gift",
                    view_more: oldTranslation.main_section?.toggle_button_text ? oldTranslation.main_section?.toggle_button_text.view_more : "View more",
                    view_less: oldTranslation.main_section?.toggle_button_text ? oldTranslation.main_section?.toggle_button_text.view_less : "View less"
                },
                upsell_msg: {
                    not_meet_condition: oldTranslation.main_section.upsell_msg.condition_not_met,
                    meet_condition: oldTranslation.main_section.upsell_msg.condition_met,
                    claimed: oldTranslation.main_section.upsell_msg.claimed,
                    for_auto_add: oldTranslation.main_section.upsell_msg.with_auto_add_opt
                },
                product_detail: {
                    free_text_content:  oldTranslation.detail_section.gift_item.free_text
                },
                manual_choose_gift: {
                    selected_text: oldTranslation.detail_section.selected_text.content,
                    claim_btn: oldTranslation.claim_btn.not_claim,
                    claimed_btn: oldTranslation.claim_btn.claimed,
                    choose_enough_gift: oldTranslation.detail_section.choose_enough_gift
                },
                gift_icon: {
                    manual: oldTranslation.icon_popup.text,
                    auto: oldTranslation.icon_popup.auto_add_text
                }
            }
        }

        this.translation = customTranslation ? this.deepMergeObject(this.DEFAULT_TRANSLATION, customTranslation) : this.DEFAULT_TRANSLATION;


        this.rules = [];

        this.discountCodeMapRuleId = new Map();

        //Check is first loading in page
        this.firstLoading = true;
        
        if(displaySettings && displaySettings.popup_new && 
            displaySettings.popup_new.custom_css &&
            displaySettings.popup_new.custom_css.trim() !== ""
        ){
            this.applyCustomCss(displaySettings.popup_new.custom_css);
        }
        this.applyStyle();
        this.initializeLocalStorage().then(async () => {
            if(this.rules.length){
                await this.#getStoreAccess();
                await this.updateCartData();
                tlAdvancedFreeGiftOverride();
            }
        });
    }

    applyCustomCss = (custom_css) => {
        var styleElement = document.getElementById("tl_custom_css_popup_new");

        if (!styleElement) {
            styleElement = document.createElement("style");
            styleElement.id = "tl_custom_css_popup_new";
            document.head.appendChild(styleElement);
        }

        styleElement.innerHTML = custom_css;
    }

    initializeLocalStorage = async () => {
        const initialTime = (new Date()).getTime() + 24 * 3600 * 1000;
        let initialData = {
            updated_at: new Date().toISOString(),
            expiredTime: initialTime,
            rules: []
        }

        const tlAdvancedFGLocalStorage = localStorage.getItem(this.LOCAL_STORAGE);
        if(!tlAdvancedFGLocalStorage){
            initialData.rules = await this.getAllRule();
        }else {
            const tlAdvancedFGLocalStorageData = JSON.parse(tlAdvancedFGLocalStorage);
            const expiredTime = tlAdvancedFGLocalStorageData.expiredTime || 0;
            if ((new Date()).getTime() > expiredTime || tlAdvancedFGLocalStorageData.updated_at < this.updateState) {
                initialData.rules = await this.getAllRule();
                initialData.updated_at = this.updateState;
            }else {
                initialData = JSON.parse(JSON.stringify(tlAdvancedFGLocalStorageData));
                initialData.rules = tlAdvancedFGLocalStorageData.rules;
            }
        }

        this.rules = await this.filterRule(initialData.rules);
        localStorage.setItem(this.LOCAL_STORAGE, JSON.stringify(initialData));
    }

    getAllRule = async () => {
        const getAllRuleReq = await fetch(window.Shopify.routes.root + `${this.PROXY_URL}/free-gift/advanced`);
        const getAllRuleRes = await getAllRuleReq.json();

        return getAllRuleRes.success ? getAllRuleRes.data : []
    }

    #getStoreAccess = async () => {
        const getShopAccessReq = await fetch(window.Shopify.routes.root + `${this.PROXY_URL}/shop`);
        const getShopAccessRes = await getShopAccessReq.json();

        this.#storeAccessToken = getShopAccessRes.data;
    }

    getVariantData = async (nonGlobalId) => {
        const idBase64 = btoa(`gid://shopify/ProductVariant/${nonGlobalId}`);
        try {
            const getVariantReq = await fetch(`https://${Shopify.shop}/api/${this.API_VERSION}/graphql.json`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Shopify-Storefront-Access-Token": this.#storeAccessToken
                },
                body: JSON.stringify({
                    query: ` query {
                        node(id: "${idBase64}") {
                            ... on ProductVariant {
                                id
                                price {
                                    amount
                                    currencyCode
                                }
                                product {
                                    id
                                    collections(first: 250){
                                        nodes {
                                            id
                                            handle
                                            title
                                        }
                                    }
                                }
                            }
                        }
                    }`
                })
            });
    
            const getVariantRes =  await getVariantReq.json();
            if(getVariantRes.data) {
                const listCollectionId = [];
                getVariantRes.data.node.product.collections.nodes.map(collection => {
                    listCollectionId.push(collection.id.split("/").pop());
                })

                const productId = getVariantRes.data.node.product.id.split("/").pop();
                this.productIdMapCollection.set(productId, listCollectionId);
                return getVariantRes.data.node;
            }else {
                return null;
            }
        } catch (error) {
            console.log("Error when getVariantData - Advanced Free Gift: ", error)
        }
    }

    compareRule(listRule) {
        listRule.sort((rule1, rule2) => {
            const date1 = new Date(rule1.created_at);
            const date2 = new Date(rule2.created_at);
            
            // Compare the dates
            return date2 - date1;
        });
        return listRule;
    }

    async checkAdvancedConditionBeforeUpdate(rule){
        //Check country target 
        if(rule.country_target_value.length){
            const ipInfoReq = await fetch('https://ipinfo.io/json');
            const ipInfoRes = await ipInfoReq.json();
            const contryTargetValue = rule.country_target_value.split(",");
            if(
                rule.country_target_type === this.COUNTRY_TARGET_TYPE.INCLUDE &&
                !contryTargetValue.includes(ipInfoRes.country)
            ){
                return false;
            }else if(
                rule.country_target_type === this.COUNTRY_TARGET_TYPE.EXCLUDE &&
                contryTargetValue.includes(ipInfoRes.country)
            ){
                return false;
            }
        }

        // Check customer target
        if(!this.currentCustomer){
            //Case: Customer is not logged and customer_target is not the case all or not_logged => false
            if(
                rule.customer_target !== this.CUSTOMER_TARGET.NOT_LOGGED &&
                rule.customer_target !== this.CUSTOMER_TARGET.ALL
            ){
                return false;
            }
        }else{
            if(rule.customer_target === this.CUSTOMER_TARGET.CUSTOMER_TAG){
                let isContainTag = false;
                const customerTags = this.currentCustomer.tags.map(tag => tag.toLocaleLowerCase());
                const customerTagetValue = rule.customer_target_value.split(",");
            
                for (let i = 0; i < customerTagetValue.length; i++) {
                    const tag = customerTagetValue[i];
                    if(customerTags.includes(tag.toLocaleLowerCase())){
                        isContainTag = true;
                        break;
                    }
                }   
                // Customer target to tag and not contain tag => false
                if(!isContainTag) return false
            }else if(
                rule.customer_target === this.CUSTOMER_TARGET.ORDER_COUNT &&
                (this.currentCustomer.orders_count < Number(rule.customer_target_value) ||
                (rule.customer_target_max_value && this.currentCustomer.orders_count > Number(rule.customer_target_max_value)))
            ){
                // Customer has order_count less than required
                return false;
            }else if(
                rule.customer_target === this.CUSTOMER_TARGET.TOTAL_SPENT &&
                (this.currentCustomer.total_spent < parseFloat(rule.customer_target_value) ||
                (rule.customer_target_max_value && this.currentCustomer.total_spent > parseFloat(rule.customer_target_max_value)))
            ){
                // Customer has total_spent less than required
                return false;
            }else if(
                rule.customer_target === this.CUSTOMER_TARGET.SPECIFIC_CUSTOMER &&
                !rule.customer_target_value.split(",").includes(String(this.currentCustomer.id))
            ){
                // Customer is not include in specific list
                return false;   
            }else if(rule.customer_target === this.CUSTOMER_TARGET.NOT_LOGGED){
                return false;
            }
        }

        return true;
    }

    filterRule = async (rules) => {
        const curenntDate = new Date().toISOString();

        const ruleFiltered = {
            all: [],
            collection: [],
            product: [],
            variant: [],
            tag: [],
        }
        for (let i = 0; i < rules.length; i++) {
            const rule = rules[i];
            this.discountCodeMapRuleId.set(rule.name, rule.id);
            // Check rule is active and active date is valid 
            if(
                rule.active &&
                curenntDate >= rule.start_at &&
                (
                    (rule.end_at && curenntDate <= rule.end_at ) ||
                    !rule.end_at
                )
            ) {
                if(!rule.advanced_conditions){
                    const checked = await this.checkAdvancedConditionBeforeUpdate(rule);
                    if(!checked) continue;
                }else {
                    const advancedCondition = JSON.parse(rule.advanced_conditions);
                    const {
                        SPECIFIC_COUNTRY, CUSTOMER_TAG, SPECIFIC_CUSTOMER, 
                        CUSTOMER_STATUS, ORDER_COUNT, TOTAL_SPENT
                    } = this.ADVANCED_CONDITION;
                    // Specific country condition
                    if(advancedCondition[SPECIFIC_COUNTRY]){
                        const specifiCountry = advancedCondition[SPECIFIC_COUNTRY];
                        const ipInfoReq = await fetch('https://ipinfo.io/json');
                        const ipInfoRes = await ipInfoReq.json();

                        if(
                            specifiCountry.type === this.COUNTRY_TARGET_TYPE.INCLUDE &&
                            !specifiCountry.targetCountry.includes(ipInfoRes.country)
                        ){
                            continue;
                        }else if(
                            specifiCountry.type === this.COUNTRY_TARGET_TYPE.EXCLUDE &&
                            specifiCountry.targetCountry.includes(ipInfoRes.country)
                        ){
                            continue;
                        }
                    }

                    if(!this.currentCustomer){
                        if(advancedCondition[CUSTOMER_STATUS] !== this.CUSTOMER_STATUS.NOT_LOGGED){
                            if(
                                advancedCondition[SPECIFIC_CUSTOMER] || 
                                advancedCondition[CUSTOMER_TAG] ||
                                advancedCondition[ORDER_COUNT] ||
                                advancedCondition[TOTAL_SPENT] ||
                                advancedCondition[CUSTOMER_STATUS] == this.CUSTOMER_STATUS.LOGGED_IN
                            ){
                                continue;
                            }
                        }
                    }else {
                        if(advancedCondition[CUSTOMER_STATUS] !== this.CUSTOMER_STATUS.NOT_LOGGED){
                            // Specific customer condition
                            if(
                                advancedCondition[SPECIFIC_CUSTOMER] && 
                                !advancedCondition[SPECIFIC_CUSTOMER].includes(String(this.currentCustomer.id))
                            ) {
                                continue;
                            }

                            // Customer tag condition
                            if(advancedCondition[CUSTOMER_TAG]){
                                let isContainTag = false;
                                const customerTags = this.currentCustomer.tags.map(tag => tag.toLocaleLowerCase());
                                const customerTagetValue = advancedCondition[CUSTOMER_TAG];

                                for (let i = 0; i < customerTagetValue.length; i++) {
                                    const tag = customerTagetValue[i];
                                    if(customerTags.includes(tag.toLocaleLowerCase())){
                                        isContainTag = true;
                                        break;
                                    }
                                }   
                                // Customer target to tag and not contain tag => false
                                if(!isContainTag) continue
                            }
                            
                            // Order count condition 
                            if(advancedCondition[ORDER_COUNT]){
                                const { min_value, max_value } = advancedCondition[ORDER_COUNT];
                                if(
                                    (this.currentCustomer.orders_count < Number(min_value) ||
                                    (max_value && this.currentCustomer.orders_count > Number(max_value)))
                                ){ 
                                    continue 
                                }
                            }

                            // Total spent condition
                            if(advancedCondition[TOTAL_SPENT]){
                                const { min_value, max_value } = advancedCondition[TOTAL_SPENT];
                                if(
                                    (this.currentCustomer.total_spent < Number(min_value) ||
                                    (max_value && this.currentCustomer.total_spent > Number(max_value)))
                                ){
                                    continue
                                }
                            }
                        }else {
                            continue
                        }
                    }
                }

                ruleFiltered[rule.apply_to_product].push(rule);
                this.ruleIdMapData.set(rule.id, rule);
            }
        }

        return [
            ...this.compareRule(ruleFiltered[this.APPLY_TO_PRODUCT.VARIANT]),
            ...this.compareRule(ruleFiltered[this.APPLY_TO_PRODUCT.PRODUCT]),
            ...this.compareRule(ruleFiltered[this.APPLY_TO_PRODUCT.COLLECTION]),
            ...this.compareRule(ruleFiltered[this.APPLY_TO_PRODUCT.TAG]),
            ...this.compareRule(ruleFiltered[this.APPLY_TO_PRODUCT.ALL]),
        ]
    }

    formatMoney = function (t, e = `{{amount_with_period_and_space_separator}} ${this.currency}`) {
        function n(t, e) {
            return void 0 === t ? e : t
        }

        function o(t, e, o, i) {
            if (e = n(e, 2), o = n(o, ","), i = n(i, "."), isNaN(t) || null == t) return 0;
            var r = (t = (t / 100).toFixed(e)).split(".");
            return r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + o) + (r[1] ? i + r[1] : "")
        }

        "string" == typeof t && (t = t.replace(".", ""));
        var i = "",
            r = /\{\{\s*(\w+)\s*\}\}/,
            a = e || this.money_format;
        switch (a.match(r)[1]) {
            case "amount":
                i = o(t, 2);
                break;
            case "amount_no_decimals":
                i = o(t, 0);
                break;
            case "amount_with_comma_separator":
                i = o(t, 2, ".", ",");
                break;
            case "amount_with_space_separator":
                i = o(t, 2, " ", ",");
                break;
            case "amount_with_period_and_space_separator":
                i = o(t, 2, " ", ".");
                break;
            case "amount_no_decimals_with_comma_separator":
                i = o(t, 0, ".", ",");
                break;
            case "amount_no_decimals_with_space_separator":
                i = o(t, 0, " ");
                break;
            case "amount_with_apostrophe_separator":
                i = o(t, 2, "'", ".")
        }
        return a.replace(r, i)
    }

    isJson(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    deepMergeObject(a, b) {
        const result = { ...a };
    
        for (const key in b) {
            if (b.hasOwnProperty(key)) {
                if (a && typeof a[key] === 'object' && typeof b[key] === 'object' && !Array.isArray(a[key])) {
                    result[key] = this.deepMergeObject(a[key], b[key]); 
                } else if(b[key] !== undefined){
                    result[key] = b[key]; 
                }
            }
        }
    
        return result;
    };

    applyStyle = () => {
        // Set header title and subtitle
        document.querySelector(".salepify-fg-advanced-header__title").innerHTML = this.translation.header.title;
        document.querySelector(".salepify-fg-advanced-header__subtitle").innerHTML = this.translation.header.subtitle;

        //Set style of popup icon 
        if(this.displaySettings.position === this.POSITION_OF_POPUP.BOTTOM_RIGHT){   
            this.iconPopupElement.style.bottom = "10px";
            this.iconPopupElement.style.right = "10px";
            this.iconPopupBadgeTextElement.style.left = "-180px";
            this.iconPopupBadgeTextElement.style.right = "unset";
        }else if(this.displaySettings.position === this.POSITION_OF_POPUP.BOTTOM_LEFT){   
            this.iconPopupElement.style.bottom = "10px";
            this.iconPopupElement.style.left = "10px";
            this.iconPopupBadgeTextElement.style.left = "unset";
            this.iconPopupBadgeTextElement.style.right = "-180px";
        }else if(this.displaySettings.position === this.POSITION_OF_POPUP.CENTER_LEFT){   
            this.iconPopupElement.style.top = "calc(50% - 35px)";
            this.iconPopupElement.style.left = "10px";
            this.iconPopupBadgeTextElement.style.left = "unset";
            this.iconPopupBadgeTextElement.style.right = "-180px";
        } else if(this.displaySettings.position === this.POSITION_OF_POPUP.CENTER_RIGHT){   
            this.iconPopupElement.style.top = "calc(50% - 35px)";
            this.iconPopupElement.style.right = "10px";
            this.iconPopupBadgeTextElement.style.left = "-180px";
            this.iconPopupBadgeTextElement.style.right = "unset";
        }

        // Set animation 

        if(this.displaySettings.animation === this.POPUP_ANIMATION.FADE_IN){
            document.documentElement.style.setProperty('--salepify-fg-advanced-show-transform', "none");
            document.documentElement.style.setProperty('--salepify-fg-advanced-hide-transform', "none"); 
        }else if(this.displaySettings.animation === this.POPUP_ANIMATION.SLIDE_IN_UP){
            document.documentElement.style.setProperty('--salepify-fg-advanced-show-transform', "translate3d(0, 0, 0))");
            document.documentElement.style.setProperty('--salepify-fg-advanced-hide-transform', "translate3d(0, -50px, 0)"); 
        }else if(this.displaySettings.animation === this.POPUP_ANIMATION.SLIDE_IN_DOWN){
            document.documentElement.style.setProperty('--salepify-fg-advanced-show-transform', "translate3d(0, 0, 0))");
            document.documentElement.style.setProperty('--salepify-fg-advanced-hide-transform', "translate3d(0, 50px, 0)"); 
        }else if(this.displaySettings.animation === this.POPUP_ANIMATION.SLIDE_IN_LEFT){
            document.documentElement.style.setProperty('--salepify-fg-advanced-show-transform', "translate3d(0, 0, 0))");
            document.documentElement.style.setProperty('--salepify-fg-advanced-hide-transform', "translate3d(50px, 0, 0)");
        }else if(this.displaySettings.animation === this.POPUP_ANIMATION.SLIDE_IN_RIGHT){
            document.documentElement.style.setProperty('--salepify-fg-advanced-show-transform', "translate3d(0, 0, 0))");
            document.documentElement.style.setProperty('--salepify-fg-advanced-hide-transform', "translate3d(-50px, 0, 0)"); 
        }else if(this.displaySettings.animation === this.POPUP_ANIMATION.ZOOM_IN){
            document.documentElement.style.setProperty('--salepify-fg-advanced-show-transform', "scale(1, 1)");
            document.documentElement.style.setProperty('--salepify-fg-advanced-hide-transform', "scale(0.3, 0.3)");
        }

        // Set background section style
        const backgroundSectionStyle = this.displaySettings.background_section;
        document.documentElement.style.setProperty('--salepify-fg-advanced-background-section-text-color', backgroundSectionStyle.color);
        document.documentElement.style.setProperty('--salepify-fg-advanced-background-section-background-color', backgroundSectionStyle.background_color);
        document.documentElement.style.setProperty('--salepify-fg-advanced-background-section-close-btn-color', backgroundSectionStyle.close_btn_color);
        document.documentElement.style.setProperty('--salepify-fg-advanced-background-section-header-font', backgroundSectionStyle.header_title.font_family);
        document.documentElement.style.setProperty('--salepify-fg-advanced-background-section-header-text-size', `${backgroundSectionStyle.header_title.font_size}px`);

        // Set main section style
        const mainSectionStyle = this.displaySettings.main_section;
        // Offer title
        document.documentElement.style.setProperty('--salepify-fg-advanced-main-section-offer-text-color', mainSectionStyle.offer_title.color);
        document.documentElement.style.setProperty('--salepify-fg-advanced-main-section-offer-text-size', `${mainSectionStyle.offer_title.font_size}px`);
        document.documentElement.style.setProperty('--salepify-fg-advanced-main-section-offer-font', mainSectionStyle.offer_title.font_family);
        // Upsell message
        document.documentElement.style.setProperty('--salepify-fg-advanced-main-section-upsell-text-color', mainSectionStyle.upsell_msg.color);
        document.documentElement.style.setProperty('--salepify-fg-advanced-main-section-upsell-font', mainSectionStyle.upsell_msg.font_family);
        document.documentElement.style.setProperty('--salepify-fg-advanced-main-section-upsell-text-size', `${mainSectionStyle.upsell_msg.font_size}px`);
        document.documentElement.style.setProperty('--salepify-fg-advanced-main-section-upsell-background-color', mainSectionStyle.upsell_msg.background_color);
        document.documentElement.style.setProperty('--salepify-fg-advanced-main-section-upsell-padding', `${mainSectionStyle.upsell_msg.padding}px`);
        // Border
        document.documentElement.style.setProperty('--salepify-fg-advanced-main-section-border-color', mainSectionStyle.border.border_color);
        document.documentElement.style.setProperty('--salepify-fg-advanced-main-section-border-width', `${mainSectionStyle.border.border_width}px`);
        document.documentElement.style.setProperty('--salepify-fg-advanced-main-section-border-radius', `${mainSectionStyle.border.border_radius}px`);

        // Set detail section style
        const detailSectionStyle = this.displaySettings.detail_section;
        // Gift item
        document.documentElement.style.setProperty('--salepify-fg-advanced-detail-section-gift-free-text-color', detailSectionStyle.gift_item.free_text_color);
        document.documentElement.style.setProperty('--salepify-fg-advanced-detail-section-gift-product-text-color', detailSectionStyle.gift_item.product_text_color);
        document.documentElement.style.setProperty('--salepify-fg-advanced-detail-section-gift-price-text-color', detailSectionStyle.gift_item.price_text_color);
        // Selected text
        document.documentElement.style.setProperty('--salepify-fg-advanced-detail-section-selected-text-color', detailSectionStyle.selected_text.color);
        // Gift selector
        document.documentElement.style.setProperty('--salepify-fg-advanced-detail-section-add-btn-color', detailSectionStyle.gift_selector.color);

        // Set claim btn style
        const claimBtnStyle = this.displaySettings.claim_btn;
        document.documentElement.style.setProperty('--salepify-fg-advanced-claim-btn-text-size', `${claimBtnStyle.font_size}px`);
        document.documentElement.style.setProperty('--salepify-fg-advanced-claim-btn-text-color', claimBtnStyle.color);
        document.documentElement.style.setProperty('--salepify-fg-advanced-claim-btn-font', claimBtnStyle.font_family);
        document.documentElement.style.setProperty('--salepify-fg-advanced-claim-btn-text-weight', claimBtnStyle.font_weight);
        document.documentElement.style.setProperty('--salepify-fg-advanced-claim-btn-background-color', claimBtnStyle.background_color);
        document.documentElement.style.setProperty('--salepify-fg-advanced-claim-btn-padding', `${claimBtnStyle.padding}px`);

        // Set icon popup style
        const iconPopupStyle = this.displaySettings.icon_popup;
        document.documentElement.style.setProperty('--salepify-fg-advanced-icon-popup-background-color', iconPopupStyle.background_color);
        document.documentElement.style.setProperty('--salepify-fg-advanced-icon-popup-border-radius', `${iconPopupStyle.border_radius}px`);
        document.documentElement.style.setProperty('--salepify-fg-advanced-icon-popup-border-width', `${iconPopupStyle.border_width}px`);
        document.documentElement.style.setProperty('--salepify-fg-advanced-icon-popup-icon-size', `${iconPopupStyle.icon_size}px`);
        document.documentElement.style.setProperty('--salepify-fg-advanced-icon-popup-icon-color', iconPopupStyle.icon_color);
        document.documentElement.style.setProperty('--salepify-fg-advanced-icon-popup-border-color', iconPopupStyle.border_color);
        document.documentElement.style.setProperty('--salepify-fg-advanced-icon-popup-text-color', iconPopupStyle.color);
    }

    handleToggle = (e) => {
        if(e && !e.target.classList.contains("salepify-fg-advanced-wrapper")) return;
        const modalWrapper = document.querySelector(".salepify-fg-advanced-wrapper");
        const modal = document.querySelector(".salepify-fg-advanced");
        if(modal.classList.contains("salepify-fg-advanced--hide")){
            modal.classList.add("salepify-fg-advanced--show");
            modal.classList.remove("salepify-fg-advanced--hide");
            modalWrapper.style.visibility = "visible";
        }else {
            modal.classList.add("salepify-fg-advanced--hide");
            modal.classList.remove("salepify-fg-advanced--show");
            modalWrapper.style.visibility = "hidden";
        }
    }

    openGiftModal = () => {
        const modalWrapper = document.querySelector(".salepify-fg-advanced-wrapper");
        const modal = document.querySelector(".salepify-fg-advanced");
        modal.classList.add("salepify-fg-advanced--show");
        modal.classList.remove("salepify-fg-advanced--hide");
        modalWrapper.style.visibility = "visible";
    }

    stringIsJson = (str) => {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    parseShowOnPagesString = (showOnPagesString) => {
        if (this.stringIsJson(showOnPagesString)) {
            return JSON.parse(showOnPagesString);
        }
    
        const showOnPages = {
            [this.SHOW_ON_PAGES.ALL]: false,
            [this.SHOW_ON_PAGES.PRODUCT]: false,
            [this.SHOW_ON_PAGES.HOME]: false,
            [this.SHOW_ON_PAGES.COLLECTION]: false,
            [this.SHOW_ON_PAGES.CART]: false,
            [this.SHOW_ON_PAGES.SPECIFIC]: []
        };
    
        if (showOnPagesString === "") {
            showOnPages[this.SHOW_ON_PAGES.ALL] = true;
            return showOnPages;
        }
    
        showOnPagesString.split(",").forEach(page => {
            showOnPages[page] = true;
        });
        return showOnPages;
    }

    checkShowOnPage = (show_on_pages) => {
        const showOnPages = this.parseShowOnPagesString(show_on_pages);
        if (showOnPages[this.SHOW_ON_PAGES.ALL]) {
            return true;
        } else if (showOnPages[this.SHOW_ON_PAGES.HOME] && this.template === "index") {
            return true;
        } else if (showOnPages[this.SHOW_ON_PAGES.COLLECTION] && this.template === "collection") {
            return true;
        } else if (showOnPages[this.SHOW_ON_PAGES.PRODUCT] && this.template === "product") {
            return true;
        } else if (showOnPages[this.SHOW_ON_PAGES.CART] && this.template === "cart") {
            return true;
        } else if (showOnPages[this.SHOW_ON_PAGES.SPECIFIC].some((url) => url === window.location.href.replace(/\/$/, '').split('#')[0].split('?')[0])) {
            return true;
        } else {
            return false;
        }
    };

    updateProductData = async (uniqueProductHandle) => {
        if(uniqueProductHandle.length){
            const productDataReq = await Promise.all(uniqueProductHandle.map(handle => fetch(window.Shopify.routes.root + `products/${handle}.js`)))
            const productDataRes = await Promise.all(productDataReq.map(req => req.json()));
    
            productDataRes.map((product) => {
                const productId = String(product.id);
                const productImage = product.images[0] ? `https:${product.images[0]}` : this.defaultImg;
                const variants = product.variants.map(variant => {
                    const variantId = String(variant.id);

                    this.shopifyIdMapData.set(variantId, {
                        id: variantId,
                        title: variant.name,
                        handle: product.handle,
                        image: variant.featured_image ? variant.featured_image.src : productImage,
                        price: variant.price / 100,
                        available: variant.available,
                        productId: productId
                    })

                    return variantId;
                })

                this.shopifyIdMapData.set(productId, {
                    id: productId,
                    title: product.title,
                    handle: product.handle,
                    image: productImage,
                    price: product.price / 100,
                    available: product.available,
                    tags: product.tags,
                    variants: variants
                });
            })
        }
    }

    extractNumberFromString = (str) => {
        const regex = /(\d+)/;
        const match = str.match(regex);
        
        if (match) {
          return parseInt(match[0]);
        } else {
          return NaN;
        }
    }

    replaceVariable = (originalString, variable, value) => {
        return originalString.split(variable).join(value);
    }

    handleReplaceVariable = (rule, currentString, remain, remainSpecific, giftNumber) => {
        let remainValue = remain
        if(rule.apply_condition_type === this.APPLY_CONDITION_TYPE.AMOUNT){
            remainValue = this.formatMoney(remain * 100);
        }

        if(remain <= 0){
            remainValue = remainSpecific
        }
        currentString = this.replaceVariable(currentString, "{{gift_number}}", String(giftNumber));
        currentString = this.replaceVariable(currentString, "{{remain}}", String(remainValue));

        return currentString;
    }

    convertHandleToTitle(str) {
        return str
            .replace('-', ' ')             // Replace hyphen with space
            .replace(/^\w/, c => c.toUpperCase()); // Capitalize the first letter of the string
    }

    getOfferTitle = (rule) => {
        const locale = Shopify?.locale || "en";
        let offerTitle = JSON.parse(rule.custom_text_display).offer_title;
            offerTitle = offerTitle[locale] 
            ? offerTitle[locale] 
            : (offerTitle.default ? offerTitle.default : offerTitle);

        let listVariableInStr = [];
        const applyTo = rule.apply_to_product;
        const shopDomain = window.Shopify.shop;
        const parents = rule.listParents;
        if(applyTo == this.APPLY_TO_PRODUCT.COLLECTION){
            listVariableInStr = Array.from(new Set(offerTitle.match(/{{collection_\d+}}/gm)));

            listVariableInStr.map((variable) => {
                const collectionIndex = this.extractNumberFromString(variable) - 1;
                const collectionData = parents[collectionIndex];
 
                offerTitle = this.replaceVariable(
                    offerTitle, variable, 
                    `<a href="https://${shopDomain}/collections/${collectionData.handle}" target="_blank">${collectionData.title ? collectionData.title : this.convertHandleToTitle(collectionData.handle)}</a>`)
            })

        }else if(applyTo == this.APPLY_TO_PRODUCT.PRODUCT){
            listVariableInStr = Array.from(new Set(offerTitle.match(/{{product_\d+}}/gm)));

            listVariableInStr.map((variable) => {
                const productIndex = this.extractNumberFromString(variable) - 1;
                const productId = parents[productIndex].shopify_id;
                const productData = this.shopifyIdMapData.get(productId);
                
                offerTitle = this.replaceVariable(offerTitle, variable, `<a href="https://${shopDomain}/products/${productData.handle}" target="_blank">${productData.title}</a>`)
            })
        }else if(applyTo == this.APPLY_TO_PRODUCT.VARIANT){
            listVariableInStr = Array.from(new Set(offerTitle.match(/{{variant_\d+}}/gm)));

            listVariableInStr.map((variable) => {
                const variantIndex = this.extractNumberFromString(variable) - 1;
                const variantId = parents[variantIndex].shopify_id;
                const variantData = this.shopifyIdMapData.get(variantId);
                
                offerTitle = this.replaceVariable(offerTitle, variable, `<a href="https://${shopDomain}/products/${variantData.handle}?variant=${variantId}" target="_blank">${variantData.title}</a>`)
            })
        }else if(applyTo === this.APPLY_TO_PRODUCT.TAG){
            const tagCollection = JSON.parse(rule.tag_collection);

            offerTitle = this.replaceVariable(offerTitle, '{{product_with_selected_tag}}', `<a href="https://${shopDomain}/collections/${tagCollection.handle}" target="_blank">from the following list</a>`)
        }

        return offerTitle;
    }

    handleViewMore = (ruleId) => {
        const currentMainSection = document.querySelector(`#salepify-fg-advanced-main-section-${ruleId}`);
        if(currentMainSection.classList.contains('salepify-fg-advanced-main-section--view-more')){
            currentMainSection.classList.remove("salepify-fg-advanced-main-section--view-more")
            currentMainSection.classList.add("salepify-fg-advanced-main-section--view-less")
            currentMainSection.querySelector(".salepify-fg-advanced-main-section__view-offer-btn").innerHTML = this.translation.main_offer.view_more;
        }else {
            currentMainSection.classList.remove("salepify-fg-advanced-main-section--view-less")
            currentMainSection.classList.add("salepify-fg-advanced-main-section--view-more")
            currentMainSection.querySelector(".salepify-fg-advanced-main-section__view-offer-btn").innerHTML = this.translation.main_offer.view_less;
        }
    }

    showIconPopUpMessage = (message, availableToClaim) => {
        this.iconPopupBadgeTextElement.innerHTML = message;
        this.iconPopupBadgeElement.style = "display: block";

        this.iconPopupBadgeElement.querySelector("p").innerHTML = availableToClaim
        this.iconPopupElement.style.animation = "tlAdvancedFGShake 1s 2"
    }

    showError(ruleId, message) {
        const errorElement = document.querySelector(`div[id^="salepify-fg-advanced-error-${ruleId}"]`);

        errorElement.style = "display: flex;";
        errorElement.querySelector(".salepify-fg-advanced-error__message").innerHTML = message;
        this.setErrTimeOut(ruleId)
    }

    setErrTimeOut(ruleId, times = 3000) {
        const currentTimeout = this.ruleIdMapTimeoutErr.get(ruleId);
        if (currentTimeout) {
            clearTimeout(currentTimeout)
        }

        this.ruleIdMapTimeoutErr.set(ruleId, setTimeout(() => {
            const errorElement = document.querySelector(`div[id^="salepify-fg-advanced-error-${ruleId}"]`);
            errorElement.style = "display: none;";
            this.ruleIdMapTimeoutErr.set(ruleId, null)
        }, times))
    }

    getTotalSelectedGift = (ruleId) => {
        const giftSelectedMapQty = this.ruleIdMapSelectedGift.get(ruleId) ?  this.ruleIdMapSelectedGift.get(ruleId) : {};

        return Object.values(giftSelectedMapQty).reduce((acc, value) => acc + value, 0) ;
    }

    changeSelectorInputValue = (ruleId, giftId, value) => {
        const currentGiftElement = document.querySelector(`#salepify-fg-advanced-gift-${ruleId}-${giftId}`);

        const qtyInputElement = currentGiftElement.querySelector(".salepify-fg-advanced-gift-qty-selector__quantity");
        qtyInputElement.value = value;

        const comparePriceElement = currentGiftElement.querySelector(".salepify-fg-advanced-gift-description__price--comapre");
        comparePriceElement.innerHTML = this.formatMoney(this.shopifyIdMapData.get(giftId).price * 100 * value);
    
        const remainGiftElement = document.querySelector(`#salepify-fg-advanced-main-section-${ruleId} .salepify-fg-advanced-footer__remain-gift-title`);
        const giftNumber = remainGiftElement.innerHTML.split("/").pop();
        remainGiftElement.innerHTML = `${this.translation.manual_choose_gift.selected_text} ${this.getTotalSelectedGift(ruleId)}/${giftNumber}`
    }

    handleChangCheckBox = (e, ruleId, giftId) => {
        const giftQuantity = this.ruleIdMapData.get(ruleId).gift_qty * this.ruleIdMapCanClaimTime.get(ruleId);
        const giftSelectedMapQty = this.ruleIdMapSelectedGift.get(ruleId) ? 
            this.ruleIdMapSelectedGift.get(ruleId) : {};
        const currentGiftElement = document.querySelector(`#salepify-fg-advanced-gift-${ruleId}-${giftId}`);

        if (e.checked) {
            const totalSelectedGift = this.getTotalSelectedGift(ruleId);
            if (totalSelectedGift < giftQuantity) {
                giftSelectedMapQty[giftId] = 1;
                currentGiftElement.querySelector(".salepify-fg-advanced-gift-qty-selector").style = "display: flex !important";
            } else {
                e.checked = false;
            }
        } else {
            delete giftSelectedMapQty[giftId];
            currentGiftElement.querySelector(".salepify-fg-advanced-gift-qty-selector").style = "display: none !important";
        }

        this.ruleIdMapSelectedGift.set(ruleId, giftSelectedMapQty);
        this.changeSelectorInputValue(ruleId, giftId, 1)
    }

    increaseGiftQuantity(ruleId, giftId) {
        const giftQuantity = this.ruleIdMapData.get(ruleId).gift_qty * this.ruleIdMapCanClaimTime.get(ruleId);
        const giftSelectedMapQty = this.ruleIdMapSelectedGift.get(ruleId);
        const totalSelectedGift = this.getTotalSelectedGift(ruleId);
        if (totalSelectedGift < giftQuantity) {
            const newValue = giftSelectedMapQty[giftId] + 1;
            giftSelectedMapQty[giftId] = newValue;
            this.ruleIdMapSelectedGift.set(ruleId, giftSelectedMapQty);
            this.changeSelectorInputValue(ruleId, giftId, newValue);
        }else {
            this.showError(ruleId, this.translation.manual_choose_gift.choose_enough_gift)
        }
    }

    decreaseGiftQuantity(ruleId, giftId) {
        const giftSelectedMapQty = this.ruleIdMapSelectedGift.get(ruleId);
        const currentValue = giftSelectedMapQty[giftId];

        const newValue = (currentValue - 1) > 0 ? (currentValue - 1) : 1;
        giftSelectedMapQty[giftId] = newValue;
        this.ruleIdMapSelectedGift.set(ruleId, giftSelectedMapQty);
        this.changeSelectorInputValue(ruleId, giftId, newValue);
    }

    changeGiftQuantity(evt, ruleId, giftId) {
        const giftQuantity = this.ruleIdMapData.get(ruleId).gift_qty * this.ruleIdMapCanClaimTime.get(ruleId);
        const giftSelectedMapQty = this.ruleIdMapSelectedGift.get(ruleId);
        const totalSelectedGift = this.getTotalSelectedGift(ruleId);
        const residualGift = giftQuantity - totalSelectedGift;
        const currentValue = giftSelectedMapQty[giftId];

        let value = parseInt(evt.value, 10);
        value = isNaN(value) ? 1 : value;
        value < 1 ? (value = 1) : "";

        const changeValue = value - currentValue;
        let newValue = value;
        if(changeValue > residualGift){
            newValue = residualGift + currentValue;
            this.showError(ruleId, this.translation.manual_choose_gift.choose_enough_gift)
        }
        evt.value = newValue;
        giftSelectedMapQty[giftId] = newValue;
        this.ruleIdMapSelectedGift.set(ruleId, giftSelectedMapQty);

        this.changeSelectorInputValue(ruleId, giftId, newValue);
    }

    renderOffer = (listParentDisplay) => {
        if(listParentDisplay.length){
            let offerMarkup = "";
            const hasMoreItem = listParentDisplay.length > 3;
            JSON.parse(JSON.stringify(listParentDisplay)).splice(0,3).map((parentId, index) => {
                const parentData = this.shopifyIdMapData.get(parentId);
                offerMarkup += `
                    <div class="salepify-fg-advanced-offer__item ${(index == 2 && hasMoreItem) ? "salepify-fg-advanced-offer__item--last" : ""}">
                        <img src="${parentData.image}" alt="${parentData.title}" width="71" height="71"/>
                        ${
                            (index == 2 && hasMoreItem) ? 
                            `<svg width="19" height="5" viewBox="0 0 19 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.0625 2.5C5.0625 3.72538 4.06913 4.71875 2.84375 4.71875C1.61837 4.71875 0.625 3.72538 0.625 2.5C0.625 1.27462 1.61837 0.28125 2.84375 0.28125C4.06913 0.28125 5.0625 1.27462 5.0625 2.5Z" fill="white"/>
                                <path d="M11.7188 2.5C11.7188 3.72538 10.7254 4.71875 9.5 4.71875C8.27462 4.71875 7.28125 3.72538 7.28125 2.5C7.28125 1.27462 8.27462 0.28125 9.5 0.28125C10.7254 0.28125 11.7188 1.27462 11.7188 2.5Z" fill="white"/>
                                <path d="M16.1562 4.71875C17.3816 4.71875 18.375 3.72538 18.375 2.5C18.375 1.27462 17.3816 0.28125 16.1562 0.28125C14.9309 0.28125 13.9375 1.27462 13.9375 2.5C13.9375 3.72538 14.9309 4.71875 16.1562 4.71875Z" fill="white"/>
                            </svg>` : ""
                        }
                    </div>
                `;
            })

            return `
                ${offerMarkup}
                <div class="salepify-fg-advanced-offer__plus-icon">
                    <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M7 0.5C7.55228 0.5 8 0.947715 8 1.5V6.5H13C13.5523 6.5 14 6.94772 14 7.5C14 8.05228 13.5523 8.5 13 8.5H8V13.5C8 14.0523 7.55228 14.5 7 14.5C6.44772 14.5 6 14.0523 6 13.5V8.5H1C0.447715 8.5 0 8.05228 0 7.5C0 6.94771 0.447715 6.5 1 6.5L6 6.5V1.5C6 0.947715 6.44772 0.5 7 0.5Z" fill="#111827"/>
                    </svg>
                </div>

                <div class="salepify-fg-advanced-gift-offer-img">
                    <div class="salepify-fg-advanced-gift-offer-img__image">
                        <img src="${this.offerImg}"/>
                    </div>
                    <div class="salepify-fg-advanced-gift-offer-img__label">
                        <p>Gift</p>
                    </div>
                </div>
            `
        }else {
            return "";
        }
    }

    renderCustomerBuy = (listParentDisplay, parentMapRequiredQty) => {
        let customerByMarkup = ``;
            
        listParentDisplay.map((parentId) => {
            const parentData = this.shopifyIdMapData.get(parentId);
            customerByMarkup += `
                <div class="salepify-fg-advanced-customer-buy-item block--flex-inline">
                    <div class="salepify-fg-advanced-customer-buy-item-info block--flex-inline">
                        <div class="salepify-fg-advanced-customer-buy-item-info__img">
                            <img src="${parentData.image}" alt="${parentData.title}" />
                        </div>

                        <div class="salepify-fg-advanced-customer-buy-item-description block--flex">
                            <a class="salepify-fg-advanced-customer-buy-item-description__title" href="/products/${parentData.handle}">
                                ${parentData.title}
                            </a>
                            <p class="salepify-fg-advanced-customer-buy-item-description__price">
                                ${this.formatMoney(parentData.price * 100)}
                            </p>

                            ${
                                parentMapRequiredQty[parentId] ? 
                                `<p class="salepify-fg-advanced-gift-info__quantity">
                                    x${parentMapRequiredQty[parentId]}
                                </p>` : ""
                            }
                        </div>      
                    </div>

                    <button class="salepify-fg-advanced-customer-buy-item__add-to-cart" onclick='window.tlAdvancedFreeGift.handleAddToTempCart("${parentData.productId ? parentData.id : parentData.variants[0]}")'>
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M5 0C5.55228 0 6 0.447715 6 1V4L9 4C9.55228 4 10 4.44772 10 5C10 5.55228 9.55228 6 9 6H6V9C6 9.55229 5.55228 10 5 10C4.44771 10 4 9.55229 4 9V6H1C0.447715 6 0 5.55228 0 5C5.96046e-08 4.44771 0.447715 4 1 4L4 4V1C4 0.447715 4.44771 0 5 0Z" fill="white"/>
                        </svg>
                    </button>
                </div>
            `;
        })
        return customerByMarkup;
    }

    renderUpsellMsg = (conditionState, autoAddGift) => {
        const upsellMsgTranslation = this.translation.upsell_msg;
        let upsellMsg = upsellMsgTranslation.not_meet_condition;

        if(conditionState === this.CONDITION_STATE.MET_BEFORE_CLAIM){
            upsellMsg = autoAddGift ? upsellMsgTranslation.for_auto_add : upsellMsgTranslation.meet_condition;
        }else if(conditionState === this.CONDITION_STATE.MET_AFFTER_CLAIM){
            upsellMsg = upsellMsgTranslation.claimed;
        }

        return upsellMsg;
    }

    renderGifts = (
        listChildDisplayIds, 
        childMapRequiredQty,  
        conditionState,
        rule
    ) => {
        let giftMarkup = "";
        let gifts = [];
        const {
            id: ruleId , 
            auto_add_gift: isAutoAdd,  
            auto_add_type: autoAddType, 
            hide_gift_out_of_stock: hideOutOfStock, 
            gift_qty: giftQty,
            gift_type: giftType
        } = rule;
        if(giftType == this.GIFT_TYPE.SAME_BUY){
            this.updateSelectedGiftWithSameBuyOpt(rule);
        }else {
            if(isAutoAdd){
                if(autoAddType == this.AUTO_ADD_TYPE.FIRST_AVAILABLE){
                    for (let i = 0; i < listChildDisplayIds.length; i++) {
                        const giftId = listChildDisplayIds[i];
                        const giftData = this.shopifyIdMapData.get(giftId);
                        
                        if(giftData.available){
                            gifts.push(giftData);
                            const selectedGift = {};
                            selectedGift[giftId] = giftQty;
                            this.ruleIdMapSelectedGift.set(ruleId, selectedGift);
                            break;
                        }
                    }
                }else{
                    const giftAutoAdd = Object.keys(childMapRequiredQty);
                    gifts = listChildDisplayIds
                        .filter((giftId) => giftAutoAdd.includes(giftId))
                        .map(giftId => this.shopifyIdMapData.get(giftId));

                    this.ruleIdMapSelectedGift.set(ruleId, childMapRequiredQty);
                }

            }else {
                listChildDisplayIds.map(giftId => {
                    const giftData = this.shopifyIdMapData.get(giftId);

                    if((hideOutOfStock && giftData.available) || !hideOutOfStock){
                        gifts.push(giftData)
                    }
                });
            }
        }
        const isConditionMet = conditionState !== this.CONDITION_STATE.NOT_MET;
        const isShowSelector =  conditionState === this.CONDITION_STATE.MET_BEFORE_CLAIM && !isAutoAdd;
        gifts.map((giftData) => {
            const giftId = giftData.id;
     
            let giftSelectedQty = 1;
            if(isAutoAdd) {
                giftSelectedQty = autoAddType == this.AUTO_ADD_TYPE.FIRST_AVAILABLE ? 
                    giftQty : childMapRequiredQty[giftData.id];
            }

            giftMarkup += `
                <div 
                    id="salepify-fg-advanced-gift-${ruleId}-${giftId}"
                    class="salepify-fg-advanced-gift block--flex-inline"
                >
                    <div class="salepify-fg-advanced-checkbox 
                        ${isShowSelector ? "salepify-fg-advanced-checkbox--show" : "salepify-fg-advanced-checkbox--hide"}"
                    >
                        <input 
                            class="salepify-fg-advanced-checkbox__inp-cbx" 
                            id="salepify-fg-advanced-checkbox-${ruleId}-${giftId}" 
                            type="checkbox"
                            onclick='window.tlAdvancedFreeGift.handleChangCheckBox(this, ${ruleId}, "${giftId}")'
                        />
                        <label class="salepify-fg-advanced-checkbox__cbx" for="salepify-fg-advanced-checkbox-${ruleId}-${giftId}">
                            <span>
                                <svg width="12px" height="10px">
                                    <use xlink:href="#salepify-fg-advanced-gift-tick-${ruleId}-${giftId}"></use>
                                </svg>
                            </span>
                        </label>
                        <svg class="salepify-fg-advanced-checkbox__inline-svg">
                            <symbol id="salepify-fg-advanced-gift-tick-${ruleId}-${giftId}" viewBox="0 0 12 10">
                            <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                            </symbol>
                        </svg>
                    </div>
                
                    <div class="salepify-fg-advanced-gift-info block--flex-inline">
                        <div class="salepify-fg-advanced-gift-info__img ${!isConditionMet ? "salepify-fg-advanced-gift-info__img--condition-not-met" : ""}">
                            <img src="${giftData.image}" />
            
                            <svg width="24" height="24" 
                                viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                                style="display: ${!isConditionMet ? "block" : "none"}"
                            >
                                <path d="M12 15V17M6 21H18C19.1046 21 20 20.1046 20 19V13C20 11.8954 19.1046 11 18 11H6C4.89543 11 4 11.8954 4 13V19C4 20.1046 4.89543 21 6 21ZM16 11V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V11H16Z" stroke="#111827" strokeWidth="2" strokeLinecap="round"/>
                            </svg>                    
                        </div>

                        <div class="salepify-fg-advanced-gift-description">
                            <a class="salepify-fg-advanced-gift-description__title" href="/products/${giftData.handle}?variant=${giftData.id}">
                                ${giftData.title}
                            </a>
                            <div class="salepify-fg-advanced-gift-description__price block--flex-inline">
                                <p class="salepify-fg-advanced-gift-description__price--free">${this.translation.product_detail.free_text_content}</p>
                                <p class="salepify-fg-advanced-gift-description__price--comapre">
                                    ${this.formatMoney(giftData.price * 100 * giftSelectedQty)}
                                </p>
                            </div>
                            ${
                                isAutoAdd ? 
                                `<p class="salepify-fg-advanced-gift-info__quantity">
                                    ${
                                        autoAddType == this.AUTO_ADD_TYPE.FIRST_AVAILABLE ? 
                                            `x${giftQty}` : `x${childMapRequiredQty[giftData.id]}`
                                    }
                                </p>` : ""
                            }
                        </div>
                    </div>

                    <div class="salepify-fg-advanced-gift-qty-selector block--flex-inline">
                        <button 
                            class="salepify-fg-advanced-gift-qty-selector__decrease"
                            onclick='window.tlAdvancedFreeGift.decreaseGiftQuantity(${ruleId}, "${giftId}")'
                        >
                            <svg width="14" height="2" viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M0 1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H13C13.2652 0 13.5196 0.105357 13.7071 0.292893C13.8946 0.48043 14 0.734784 14 1C14 1.26522 13.8946 1.51957 13.7071 1.70711C13.5196 1.89464 13.2652 2 13 2H1C0.734784 2 0.48043 1.89464 0.292893 1.70711C0.105357 1.51957 0 1.26522 0 1Z" fill="white"/>
                            </svg>
                        </button>

                        <input
                            type="text"
                            class="salepify-fg-advanced-gift-qty-selector__quantity"
                            value="1"
                            min="1"
                            onchange='window.tlAdvancedFreeGift.changeGiftQuantity(this, ${ruleId}, "${giftId}")'
                        />

                        <button 
                            class="salepify-fg-advanced-gift-qty-selector__increase"
                            onclick='window.tlAdvancedFreeGift.increaseGiftQuantity(${ruleId}, "${giftId}")'
                        >
                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M5 0C5.55228 0 6 0.447715 6 1V4L9 4C9.55228 4 10 4.44772 10 5C10 5.55228 9.55228 6 9 6H6V9C6 9.55229 5.55228 10 5 10C4.44771 10 4 9.55229 4 9V6H1C0.447715 6 0 5.55228 0 5C5.96046e-08 4.44771 0.447715 4 1 4L4 4V1C4 0.447715 4.44771 0 5 0Z" fill="white"/>
                            </svg>
                        </button>
                    </div> 
                </div>
            `;
        });

        return giftMarkup;
    }

    mergeCartTempToCart = async () => {
        this.loadingWhenClaim();
        const items = [];
        const discountCodes = []
        Array.from(this.itemsInTempCart).map(([itemId, itemData]) => {
            items.push({
                'id': itemId,
                'quantity': itemData.quantity
            })
        });

        Array.from(this.giftsInTempCart).map(([giftId, giftData]) => {
            Object.entries(giftData.ruleIdMapQty).map(([id, quantity]) => {
                const ruleId = Number(id);
                const ruleData = this.ruleIdMapData.get(ruleId);
                const itemData = {
                    id: giftId,
                    quantity: quantity,
                    properties: {}
                }
                itemData.properties[this.PROPERTY] = ruleId;
                items.push(itemData);

                discountCodes.push(ruleData.name)
            })
        });

        await fetch(window.Shopify.routes.root + 'cart/add.js?app=salepify', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                'items': items
            })
        });

        await this.applyDiscounts(discountCodes);

        if(!window.TLCustomEventGiftsAdvanced){
            window.location.reload();
        } else if (window.TLCustomEventGiftsAdvanced == 1) {
            window.dispatchEvent(new CustomEvent("TLCustomEvent:FreeGiftsAdvanced-mergeCartTempToCart"));
        }
    }

    handleAddToTempCart = async (variantId) => {
        // Update the value of the item in the temporary cart 
        const currentItemDataInTempCart = this.itemsInTempCart.get(variantId) ? 
            this.itemsInTempCart.get(variantId) : { quantity: 0, key: null};

        currentItemDataInTempCart.quantity ++;

        let newKey = currentItemDataInTempCart.key;
        // Check if field key is invalid => get key for item has id = variantid  
        if(!newKey) {
            const itemInCartArr = Array.from(this.itemsInCart);
            for (let i = 0; i < itemInCartArr.length; i++) {
                const [key, itemData] = itemInCartArr[i];
                
                if(itemData.id === variantId){
                    newKey = key;
                    break;
                }
            }
        }


        // After checking cart, if there are no item has id = variantId
        if(!newKey){    
            // Assign newKey = variantId
            newKey = variantId;
            
            const itemData = this.shopifyIdMapData.get(variantId);

            let collectionIds = this.productIdMapCollection.get(itemData.productId)
            if(!collectionIds) {
                await this.getVariantData(variantId);
                collectionIds = this.productIdMapCollection.get(itemData.productId)
            }
            // Add a new key = variantId ro itemsInCart
            this.itemsInCart.set(variantId, {
                id: variantId,
                price: itemData.price,
                quantity: 1 ,
                productId: itemData.productId,
                collectionIds: collectionIds
            })
        }else {
            // Update quantity to itemInCart variable
            const currentItemDataInCart = this.itemsInCart.get(newKey);
            currentItemDataInCart.quantity ++;
            this.itemsInCart.set(newKey, currentItemDataInCart);
        }
        //Update data itemsInTempCart
        this.itemsInTempCart.set(variantId, {
            ...currentItemDataInTempCart,
            key : newKey
        });

        this.reRender();
    }

    handleRemoveFromTempCart = (variantId) => {
        let listItemRemove = [];
        if(variantId){
            listItemRemove.push(this.itemsInTempCart.get(variantId))
            this.itemsInTempCart.delete(variantId);
        }else {
            Array.from(this.itemsInTempCart).map(([itemId, itemData]) => {
                listItemRemove.push(itemData);
            })

            this.itemsInTempCart.clear();
        }

        listItemRemove.map(itemRemove => {
            const key = itemRemove.key;
            const currentItemDataInCart = this.itemsInCart.get(key);
            const newQty = currentItemDataInCart.quantity - itemRemove.quantity;

            if(newQty > 0){
                currentItemDataInCart.quantity = newQty;
                this.itemsInCart.set(key, currentItemDataInCart);
            }else {
                this.itemsInCart.delete(key);
            }
        })

        if(this.itemsInTempCart.size == 0) {
            this.giftsInTempCart.clear();
        }
        this.ruleIdMapParentInCart.clear()
        this.reRender();
    }

    updateGiftsInTempCart = (ruleId, isAutoAdd = false) => {
        const giftSelected = this.ruleIdMapSelectedGift.get(ruleId);

        Object.entries(giftSelected).map(([itemId, quantity]) => {
            // Update giftsInTempCart variable
            const initialData = {
                id: itemId,
                quantity: quantity,
                isAutoAdd: isAutoAdd, 
                ruleIdMapQty: {}
            }
            const curentData = this.giftsInTempCart.get(itemId);
            if(curentData){
                initialData.quantity += curentData.quantity;
                initialData.ruleIdMapQty = JSON.parse(JSON.stringify(curentData.ruleIdMapQty));
            }
            const currentGiftQtyOfRule = initialData.ruleIdMapQty[ruleId] ? initialData.ruleIdMapQty[ruleId] : 0;
            initialData.ruleIdMapQty[ruleId] =  currentGiftQtyOfRule + quantity;

            this.giftsInTempCart.set(itemId, initialData);
        })
    }

    handleAddGiftToTempCart = (ruleId) => {
        this.updateGiftsInTempCart(ruleId);
        this.reRender();
    }

    handleRemoveGiftFromTempCart = (variantId) => { 
        this.giftsInTempCart.delete(variantId);
        this.reRender();
    }

    loadingWhenClaim = () => {
        document.querySelectorAll(`.salepify-fg-advanced-wrapper button, 
            .salepify-fg-advanced-wrapper .salepify-fg-advanced-checkbox__inp-cbx, 
            .salepify-fg-advanced-wrapper .salepify-fg-advanced-gift-qty-selector__quantity`
        ).forEach(ele =>  ele.setAttribute("disabled", ''))
        
        //Add loading to button claim
        document.querySelectorAll(".salepify-fg-advanced-wrapper .salepify-fg-advanced-footer__claim-btn").forEach(ele => {
            ele.setAttribute('disabled', '')
            ele.classList.add("salepify-fg-loading");
            ele.innerHTML = '<div class="button-loader"></div>';
        });

        //Add loading to temp Cart button
        const addToTempCartBtn = document.querySelector(".salepify-fg-advanced-wrapper .salepify-fg-advanced-temp-cart__add-to-cart-btn")
        addToTempCartBtn.setAttribute('disabled', '')
        addToTempCartBtn.classList.add("salepify-fg-loading");
        addToTempCartBtn.innerHTML = '<div class="button-loader"></div>';

        const removeFromCartBtn = document.querySelector(".salepify-fg-advanced-wrapper .salepify-fg-advanced-temp-cart__remove-all-btn");
        removeFromCartBtn.setAttribute('disabled', '')
        removeFromCartBtn.style.color = '#d7d7d7';
    }

    removeLoading = () => {
        document.querySelectorAll(`.salepify-fg-advanced-wrapper button, 
            .salepify-fg-advanced-wrapper .salepify-fg-advanced-checkbox__inp-cbx, 
            .salepify-fg-advanced-wrapper .salepify-fg-advanced-gift-qty-selector__quantity`
        ).forEach(ele =>  ele.removeAttribute("disabled"))

        this.reRender();
    }

    #getCartData = async () => {
        const getCartDataReq = await fetch(`https://${window.Shopify.shop}/api/${this.API_VERSION}/graphql.json`, {
            method: 'POST',
            headers: {
                "Accept": 'application/json',
                "Content-Type": 'application/json',
                "X-Shopify-Storefront-Access-Token": this.#storeAccessToken,
            },
            body: JSON.stringify({
                query: `query cartQuery($cartId: ID!) {
                    cart(id: $cartId) {
                        id
                        createdAt
                        updatedAt
                        checkoutUrl
                        discountCodes{
                            code
                            applicable
                        }
                    }
                }`,
                variables: {
                    "cartId": `gid://shopify/Cart/${this.cartId}`
                }
            })
        }) 

        return await getCartDataReq.json()
    }

    #updateCartDiscountCodes = async (discounts) => {
        const getCartDataReq = await fetch(`https://${window.Shopify.shop}/api/${this.API_VERSION}/graphql.json`, {
            method: 'POST',
            headers: {
                "Accept": 'application/json',
                "Content-Type": 'application/json',
                "X-Shopify-Storefront-Access-Token": this.#storeAccessToken,
            },
            body: JSON.stringify({
                query: `mutation updateCartDiscountCodes($cartId: ID!, $discountCodes: [String!] ) {
                    cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
                        cart {
                            id
                            discountCodes{
                                code
                                applicable
                            }
                        }
                        
                        userErrors {
                            field
                            message
                        }
                    }
                }`,
                variables: {
                    "cartId": `gid://shopify/Cart/${this.cartId}`,
                    "discountCodes": discounts
                }
            })
        }) 

        return await getCartDataReq.json()
    }

    applyDiscounts = async (discounts) => {
        try {
            const getCartDataReq = await this.#getCartData();

            const otherDiscountsInCart = [];
            const discountsAppInCart = [];

            let newDiscounts = [];
            let statusDCInCart = [];

            if(getCartDataReq.data.cart){
                statusDCInCart = getCartDataReq.data.cart.discountCodes;
                getCartDataReq.data.cart.discountCodes.map((discount) => {
                    if(this.discountCodeMapRuleId.get(discount.code)){
                        discountsAppInCart.push(discount.code)
                    }else {
                        otherDiscountsInCart.push(discount.code)
                    }
                });

                const discountsNeedToApply = discounts.filter(discount => !discountsAppInCart.includes(discount));

                if(discountsNeedToApply.length !== 0 ){
                    newDiscounts = [...discountsNeedToApply, ...discountsAppInCart, ...otherDiscountsInCart];
                } 
            } else {
                // Case: The cart has not been initialized, it is necessary to retrieve the cartID
                const cartDataReq = await fetch("/cart.js");
                const cartDataRes = await cartDataReq.json();
                this.cartId = cartDataRes.token;
                newDiscounts = discounts
            }

            if(newDiscounts.length){
                const applyDiscount = await this.#updateCartDiscountCodes(newDiscounts.splice(0, 5));
                statusDCInCart =  applyDiscount?.data?.cartDiscountCodesUpdate?.cart?.discountCodes;
            }
            const appliedDC = statusDCInCart.filter((discount) => discounts.includes(discount.code) && discount.applicable)
            return appliedDC.length == discounts.length;
        } catch (error) {
            console.log("Error when applyDiscounts - Salepify Advanced Gift: ", error)
        }
    }

    handleAddGift = async (listRuleId) => {
        try {
            const items = [];
            const discountCodes = [];
            for (let i = 0; i < listRuleId.length; i++) {
                const ruleId = listRuleId[i];
                const ruleData = this.ruleIdMapData.get(ruleId);

                const claimTime = ruleData.auto_add_gift ? this.ruleIdMapCanClaimTime.get(ruleId) : 1;
                let giftSelectedMapQty = this.ruleIdMapSelectedGift.get(ruleId) 
                    ? this.ruleIdMapSelectedGift.get(ruleId) : {};
            
                Object.entries(giftSelectedMapQty).map(([variantId, quantity]) => {
                    items.push({
                        id: variantId,
                        quantity: quantity * claimTime,
                        properties: {
                            [this.PROPERTY]: ruleId
                        }
                    })
                });

                discountCodes.push(ruleData.name);
            }

            const addCartReq = await fetch(window.Shopify.routes.root + 'cart/add.js?app=salepify', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    'items': items
                })
            });

            this.itemsInCart = new Map()
            const appliedDC = await this.applyDiscounts(discountCodes);
            return appliedDC 
                ? addCartReq
                : new Response(
                    JSON.stringify({status: 400, description: "Unable to apply discount to the cart" }), 
                    { "status": 400, "Content-Type": "application/json" }
                );
        } catch (error) {
            console.log("Error when handleAddGift - Salepify Advanced Gift: ", error)
        }
    }

    handleAddGiftAndReload = async (ruleId) => { 
        this.loadingWhenClaim();
        const res = await this.handleAddGift([ruleId]);

        if(res.status !== 200){
            const resJson = await res.json();
            this.showError(ruleId, resJson.description);
            this.removeLoading();
            return;
        }
        if(!window.TLCustomEventGiftsAdvanced){
            window.location.reload();
        } else if (window.TLCustomEventGiftsAdvanced == 1) {
            window.dispatchEvent(new CustomEvent("TLCustomEvent:FreeGiftsAdvanced-handleAddGiftAndReload"));
        }
    }

    handleRemoveGift = async (listRemove) => {
        try {
            const updates = {};

            for (let i = 0; i < listRemove.length; i++) {
                const {  id,  removeTime} = listRemove[i];
                const rule = this.ruleIdMapData.get(id)
                const giftAddedByApp = this.ruleIdMapGiftAddedByApp.get(id);

                let numberGiftNeedToRemove = rule.gift_qty * removeTime;

                giftAddedByApp.map(gift => {
                    let newQty = gift.quantity - numberGiftNeedToRemove;

                    if(numberGiftNeedToRemove > 0){
                        if(gift.quantity - numberGiftNeedToRemove >= 0){
                            numberGiftNeedToRemove = 0;
                        }else {
                            newQty = 0;
                            numberGiftNeedToRemove -= gift.quantity;
                        }
                    }

                    updates[gift.key] = newQty;
                })
            }

            await fetch(window.Shopify.routes.root + 'cart/update.js?app=salepify', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
            });
        } catch (error) {
            console.log("Error when handleRemoveGift - Salepify Advanced Gift: ", error)
        }
    }

    updateCartData = async () => {
        try {
            const cartDataReq = await fetch(window.Shopify.routes.root + 'cart.js')
            const cartDataRes = await cartDataReq.json();

            this.cartId = cartDataRes.token;
            const itemsInCart = new Map();
            const ruleIdMapGiftQtyInCart = new Map();
            const ruleIdMapGiftAddedByApp = new Map();
            const ruleIdMapParentInCart = new Map();
            if(cartDataRes.items.length){
                let ratio = 1;
                for (let i = 0; i < cartDataRes.items.length; i++) {
                    const item = cartDataRes.items[i];
                    if(!isNaN(item.price/item.presentment_price)){
                        ratio = item.price / item.presentment_price;
                        break;
                    }
                }
                
                for (let i = 0; i < cartDataRes.items.length; i++) {
                    const item = cartDataRes.items[i];
                        
                    const itemKey = item.key;
                    const itemId = String(item.id);
                    const productId = String(item.product_id);

                    const itemData = {
                        id: itemId,
                        price: item.final_price / ratio,
                        quantity: item.quantity ,
                        productId: productId,
                        collectionIds: this.productIdMapCollection.get(productId)
                    }

                    if(!itemData.collectionIds){
                        await this.getVariantData(itemId);
                        itemData.collectionIds = this.productIdMapCollection.get(productId);
                    }

                    let currentAppliedRuleId = null;
                    item.discounts.map(discount => {
                        if (this.discountCodeMapRuleId.get(discount.title)) {
                            currentAppliedRuleId = this.discountCodeMapRuleId.get(discount.title)
                        }
                    })

                    let ruleInProperty = null;
                    // If has property => is gift added from app 
                    if(item.properties[this.PROPERTY]){
                        const ruleId = item.properties[this.PROPERTY];
                        ruleInProperty = this.ruleIdMapData.get(ruleId);
                        if(ruleInProperty){
                            // Save list gift added from app by RuleId
                            const currentGiftInCart = ruleIdMapGiftAddedByApp.get(ruleId) ?
                                ruleIdMapGiftAddedByApp.get(ruleId) : [];

                            ruleIdMapGiftAddedByApp.set(ruleId, [...currentGiftInCart, {
                                key: itemKey,
                                quantity: item.quantity
                            }])
                        }
                    }

                    // Case: Item is applied discount => gift
                    // Or: Item has original price equals 0 and has property of app => is Gift
                    if(currentAppliedRuleId || (ruleInProperty && item.final_price == 0)){
                        const ruleData = currentAppliedRuleId ? this.ruleIdMapData.get(currentAppliedRuleId) : ruleInProperty;
                        const ruleId = ruleData.id;
                        // Update data for ruleIdMapGiftQtyInCart variable
                        const currentGiftQtyInCart = ruleIdMapGiftQtyInCart.get(ruleId) 
                            ? ruleIdMapGiftQtyInCart.get(ruleId) : 0;

                        ruleIdMapGiftQtyInCart.set(ruleId, currentGiftQtyInCart + item.quantity );

                        // Update data for ruleIdMapParentInCart variable with gift option same buy
                        if(ruleData.gift_type == this.GIFT_TYPE.SAME_BUY){
                            const currentParentInCart = ruleIdMapParentInCart.get(ruleId) || {};
                            currentParentInCart[itemId] = item.price / ratio;
                            ruleIdMapParentInCart.set(ruleId, currentParentInCart);
                        }
                    }else {
                        itemsInCart.set(itemKey, itemData);
                    }
                }
            }

            this.itemsInCart = new Map(itemsInCart);
            this.ruleIdMapGiftQtyInCart = new Map(ruleIdMapGiftQtyInCart);
            this.ruleIdMapGiftAddedByApp = new Map(ruleIdMapGiftAddedByApp);
            this.ruleIdMapParentInCart = new Map(ruleIdMapParentInCart);
            //Clear temp cart
            this.itemsInTempCart.clear();
            this.giftsInTempCart.clear();

            if(this.firstLoading){
                await this.render();
                this.firstLoading = false;
            }else{
                await this.reRender();
            }
        } catch (error) {
            console.log("Error when updateCartData - Salepify Advanced Gift: ", error)
        }
    }

    getRemain = (rule) => {
        const ruleId = rule.id;
        let totalGiftInCart = this.ruleIdMapGiftQtyInCart.get(ruleId) ?
            this.ruleIdMapGiftQtyInCart.get(ruleId) : 0;  

        const giftIdMapQtyInTempCart = {};
        if(this.giftsInTempCart.size){
            if(rule.gift_type == this.GIFT_TYPE.SAME_BUY){
                Array.from(this.giftsInTempCart).map(([giftId, giftData]) => {
                    const giftQtyOfRule = giftData.ruleIdMapQty[ruleId];
                    if(giftQtyOfRule){
                        giftIdMapQtyInTempCart[giftId] = giftQtyOfRule;
                        totalGiftInCart += giftQtyOfRule;
                    }
                })
            }else {
                rule.listChilds.map(gift =>{
                    const giftId = gift.shopify_id;
                    // Count gift in temp cart
                    const giftDataInTempCart = this.giftsInTempCart.get(giftId);
                    if(giftDataInTempCart && giftDataInTempCart.ruleIdMapQty[ruleId]){
                        const giftQtyOfRule = giftDataInTempCart.ruleIdMapQty[ruleId];
                        giftIdMapQtyInTempCart[giftId] = giftQtyOfRule;
                        totalGiftInCart += giftQtyOfRule;
                    }
                })
            }
        }
        let totalProductApplied = 0;
        let numberProductApplied = 0;
        // Store the quantity of parent in cart
        const parentIdMapQty = new Map();
        const parentInCart = this.ruleIdMapParentInCart.get(ruleId) || {};
        // Get apply total and quantity of apply product
        if(rule.apply_to_product === this.APPLY_TO_PRODUCT.ALL){
            Array.from(this.itemsInCart).map(([key, variantData]) => {
                numberProductApplied += variantData.quantity;
                totalProductApplied += variantData.price * variantData.quantity;
                parentInCart[variantData.id] = variantData.price;
            })
        }else if(rule.apply_to_product === this.APPLY_TO_PRODUCT.PRODUCT){
            const parentShopifyIds = rule.listParents.map(parent => parent.shopify_id);
            Array.from(this.itemsInCart).map(([key, variantData]) => {
                if(parentShopifyIds.includes(variantData.productId)){
                    let currentQty = parentIdMapQty.get(variantData.productId) ? parentIdMapQty.get(variantData.productId) : 0;
                    currentQty += variantData.quantity;
                    numberProductApplied += variantData.quantity;
                    totalProductApplied += variantData.price * variantData.quantity;

                    parentIdMapQty.set(variantData.productId, currentQty);
                    parentInCart[variantData.id] = variantData.price;
                }
            })
        }else if(rule.apply_to_product === this.APPLY_TO_PRODUCT.VARIANT){
            const parentShopifyIds = rule.listParents.map(parent => parent.shopify_id);
            Array.from(this.itemsInCart).map(([key, variantData]) => {
                if(parentShopifyIds.includes(variantData.id)){
                    let currentQty = parentIdMapQty.get(variantData.id) ? parentIdMapQty.get(variantData.id) : 0;
                    currentQty += variantData.quantity;
                    numberProductApplied += variantData.quantity;
                    totalProductApplied += variantData.price * variantData.quantity;

                    parentIdMapQty.set(variantData.id, currentQty);
                    parentInCart[variantData.id] = variantData.price;
                }
            })
        }else if(rule.apply_to_product === this.APPLY_TO_PRODUCT.COLLECTION){
            const parentCollectionIds = rule.listParents.map( parent => parent.shopify_id)
            Array.from(this.itemsInCart).map(([key, variantData]) => {
                let applyCollectionId = null
                variantData.collectionIds.some(collectionId => {
                    if(parentCollectionIds.includes(collectionId)){
                        applyCollectionId = collectionId
                        return true;
                    }else { return false }
                })

                if(applyCollectionId){
                    let currentQty = parentIdMapQty.get(applyCollectionId) ? parentIdMapQty.get(applyCollectionId) : 0;
                    currentQty += variantData.quantity;
                    numberProductApplied += variantData.quantity;
                    totalProductApplied += variantData.price * variantData.quantity;
                    parentIdMapQty.set(applyCollectionId, currentQty);
                    parentInCart[variantData.id] = variantData.price;
                }
            })
        }else if(rule.apply_to_product === this.APPLY_TO_PRODUCT.TAG){
            const parentCollection = JSON.parse(rule.tag_collection);
            const parentCollectionId = parentCollection.id.split("/").pop();

            Array.from(this.itemsInCart).map(([key, variantData]) => {
                if(variantData.collectionIds.includes(parentCollectionId)){
                    numberProductApplied += variantData.quantity;
                    totalProductApplied += variantData.price * variantData.quantity;
                    parentInCart[variantData.id] = variantData.price;
                }
            })
        }
        this.ruleIdMapParentInCart.set(ruleId, parentInCart);

        // How many time can be recivied gift
        let canClaimCount =  0;
         // Initial a array contain all parent quantity
        const parentQtyInCarts = [];
         // Array contain the required specific quantity of parent
        const parentRequiredQty = [];

        if(rule.apply_condition_type === this.APPLY_CONDITION_TYPE.AMOUNT) {
            canClaimCount = Math.floor(totalProductApplied / (rule.apply_condition_value * this.currencyRate));
        }else {
            canClaimCount = Math.floor(numberProductApplied / rule.apply_condition_value);
        }

        if(rule.require_specific_qty){
            let tempCanClaimCount = 0;
            
            rule.listParents.map((parent) => {
                if(parent.quantity){
                    parentRequiredQty.push(parent.quantity);
                    parentQtyInCarts.push(parentIdMapQty.get(parent.shopify_id) ? parentIdMapQty.get(parent.shopify_id) : null);
                }
            })

            let stillApplicable = true;
            while(stillApplicable){
                // Check all required parent product is added to cart
                if(parentRequiredQty.every((requiredQty, index) => parentQtyInCarts[index] >= (requiredQty *(tempCanClaimCount + 1)))){
                    tempCanClaimCount ++;
                }else {
                    stillApplicable = false;
                }
            }

            // After checking required parent, assign canClaimCount = tempCanClaimCount
            if(canClaimCount >= tempCanClaimCount){
                canClaimCount = tempCanClaimCount;
            }
        }

        if(rule.maximum_per_order && canClaimCount >= rule.maximum_per_order){
            canClaimCount = rule.maximum_per_order
        }

        // How many time recivied gift
        let claimedCount = totalGiftInCart / rule.gift_qty;
        
        let conditionState = this.CONDITION_STATE.NOT_MET;
        let remain = 0;
        // let giftNumber = 0;
        let remainSpecific = 0;

        //Set canClaimTime of rule  = 1
        this.ruleIdMapCanClaimTime.set(ruleId, 1)
        // Case: canClaim > claimed => add gift to cart
        if(canClaimCount > claimedCount ){
            conditionState = this.CONDITION_STATE.MET_BEFORE_CLAIM;
            // giftNumber = rule.gift_qty * ();

            this.ruleIdMapCanClaimTime.set(ruleId, (canClaimCount * rule.gift_qty - totalGiftInCart) / rule.gift_qty)
        }else{
            // Remove gift from temp cart when canClaimCount < claimedCount
            if(canClaimCount < claimedCount && this.itemsInTempCart.size){
                let needToRemoveQty = (claimedCount - canClaimCount) * rule.gift_qty;
                Object.entries(giftIdMapQtyInTempCart).map(([giftId, quantity]) => {
                    if(needToRemoveQty > 0){
                        const giftData = this.giftsInTempCart.get(giftId);
                        const diffQty = needToRemoveQty - giftData.quantity;

                        if(diffQty > 0){
                            needToRemoveQty -= quantity;
                            giftData.quantity -= quantity;
                            delete giftData.ruleIdMapQty[ruleId];
                            
                        }else {
                            giftData.quantity -= needToRemoveQty;
                            giftData.ruleIdMapQty[ruleId] = quantity - needToRemoveQty;
                            needToRemoveQty = 0;
                        }
                        this.giftsInTempCart.set(giftId, giftData);

                        if(giftData.quantity <= 0){
                            this.giftsInTempCart.delete(giftId);
                        }
                    }
                })
            }
            // Case: canClaim =< claimed => Check next count
            let targetClaimCount = canClaimCount + 1;
            if(rule.maximum_per_order && targetClaimCount >= rule.maximum_per_order){
                targetClaimCount = rule.maximum_per_order
            }

            if(targetClaimCount > canClaimCount){
                if(rule.apply_condition_type === this.APPLY_CONDITION_TYPE.AMOUNT) {
                    remain = (rule.apply_condition_value  * this.currencyRate * targetClaimCount - totalProductApplied);
                }else {
                    remain = (rule.apply_condition_value * targetClaimCount - numberProductApplied);
                }

                if(rule.require_specific_qty){
                    parentRequiredQty.map((quantity, index) => {
                        if(parentQtyInCarts[index]){
                            remainSpecific += (quantity * targetClaimCount - parentQtyInCarts[index]) > 0 ? 
                                (quantity * targetClaimCount - parentQtyInCarts[index]) : 0;
                        }else {
                            remainSpecific += quantity * targetClaimCount
                        }
                    })
                }
            }else {
                conditionState = this.CONDITION_STATE.MET_AFFTER_CLAIM;
            }
        }

        return [conditionState, claimedCount, canClaimCount, remain, remainSpecific]
    }

    updateSelectedGiftWithSameBuyOpt = (rule) => {
        const ruleId = rule.id;
        const parentInCart = this.ruleIdMapParentInCart.get(ruleId);

        if (parentInCart) {
            const cheapestParentInCart = Object.entries(parentInCart).reduce(
                (cheapest, [variantId, price]) => {
                    return price < cheapest.price ? { id: variantId, price } : cheapest;
                },
                { id: null, price: Number.MAX_VALUE }
            );

            if (cheapestParentInCart.id) {
                this.ruleIdMapSelectedGift.set(ruleId, {
                    [cheapestParentInCart.id]: rule.gift_qty,
                });
            }
        }
    }

    updateSelectedGifts = (rule) => {
        const ruleId = rule.id;
        if(rule.gift_type == this.GIFT_TYPE.SAME_BUY){
            this.updateSelectedGiftWithSameBuyOpt(rule);

            return true;
        }else {
            if(rule.auto_add_gift) {
                const listChildDisplayIds = [];
                const childMapRequiredQty = {}
                rule.listChilds.map(child =>{
                    listChildDisplayIds.push(child.shopify_id);
                    if(child.quantity){
                        childMapRequiredQty[child.shopify_id] = child.quantity;
                    }
                })
                if(rule.auto_add_type == this.AUTO_ADD_TYPE.FIRST_AVAILABLE){
                    for (let i = 0; i < listChildDisplayIds.length; i++) {
                        const giftId = listChildDisplayIds[i];
                        const giftData = this.shopifyIdMapData.get(giftId);
                        
                        if(giftData.available){
                            const selectedGift = {};
                            selectedGift[giftId] = rule.gift_qty;
                            this.ruleIdMapSelectedGift.set(ruleId, selectedGift);
                            break;
                        }
                    }
                }else{
                    this.ruleIdMapSelectedGift.set(ruleId, childMapRequiredQty);
                }
                return true;
            }
        }
        return false;
    }

    render = async () => {
        const bodyElement = document.querySelector(".salepify-fg-advanced-body");
        bodyElement.innerHTML = '<div class="loader"></div>'
        let bodyHtml = "";
        const listRuleNeedToAddGift = [];
        const listRuleNeedToRemoveGift = [];

        let availableToClaim = 0;
        let needToReload = false
        let hasRuleMetCondition = false;
        for (let i = 0; i < this.rules.length; i++) {
            const rule = this.rules[i];
            const ruleId = rule.id;
            const [conditionState, claimedCount, canClaimCount, remain, remainSpecific] = this.getRemain(rule);
            
            if(claimedCount < canClaimCount) {
                rule.auto_add_gift ? listRuleNeedToAddGift.push(ruleId) : null;
            }else if(claimedCount > canClaimCount){
                rule.auto_remove_gift ? listRuleNeedToRemoveGift.push({
                    id: ruleId,
                    removeTime: claimedCount - canClaimCount
                }): null;
            }
            
            // Store handle of parent and child product
            const uniqueProductHandle = new Set();
            
            // Store list parent id in order current product => required => rest product 
            const listChildDisplayIds = [];
            // ChildId map quantity required
            const childMapRequiredQty = {}
            rule.listChilds.map(child =>{
                listChildDisplayIds.push(child.shopify_id);
                if(!this.shopifyIdMapData.get(child.product_id)){
                    uniqueProductHandle.add(child.handle)
                }
                if(child.quantity){
                    childMapRequiredQty[child.shopify_id] = child.quantity;
                }
            })

            // ParentId map quantity required
            const parentMapRequiredQty = {};

            const requireParents = []
            const highPriorityParents = [];
            const lowPriorityParents = [];
            const productIdKey = rule.apply_to_product === this.APPLY_TO_PRODUCT.PRODUCT ? "shopify_id" : "product_id";

            if(
                (rule.apply_to_product === this.APPLY_TO_PRODUCT.PRODUCT) ||
                (rule.apply_to_product === this.APPLY_TO_PRODUCT.VARIANT)
            ){
                rule.listParents.map(parent =>{
                    const productId = parent[productIdKey];
                    if(!this.shopifyIdMapData.get(productId)){
                        uniqueProductHandle.add(parent.handle);
                    }

                    if(productId == this.currentProductId){
                        parent.quantity ? requireParents.unshift(parent.shopify_id) : highPriorityParents.unshift(parent.shopify_id);
                    }else {
                        parent.quantity ? requireParents.push(parent.shopify_id) : lowPriorityParents.push(parent.shopify_id);
                    }
                    parentMapRequiredQty[parent.shopify_id] = parent.quantity;
                })
            }

            // Store list parent id in order current product => required => rest product 
            const listParentDisplayIds = [...requireParents, ...highPriorityParents, ...lowPriorityParents];
            await this.updateProductData(Array.from(uniqueProductHandle));
            
            if(rule.show_free_gift_widget && this.checkShowOnPage(rule.show_on_pages)){
                if(claimedCount < canClaimCount && !rule.auto_add_gift) {
                    hasRuleMetCondition = true;
                }
                const totalGift = rule.gift_qty * this.ruleIdMapCanClaimTime.get(ruleId);
                
                bodyHtml += `
                    <div id="salepify-fg-advanced-main-section-${ruleId}"  
                        class="salepify-fg-advanced-main-section block--flex 
                        ${i == 0 ? " salepify-fg-advanced-main-section--view-more" : " salepify-fg-advanced-main-section--view-less"}
                        ${conditionState !== this.CONDITION_STATE.NOT_MET ? " salepify-fg-advanced-main-section--allow-claim" : ""}
                        ${conditionState === this.CONDITION_STATE.MET_AFFTER_CLAIM ? " salepify-fg-advanced-main-section--claimed" : ""}" 
                    >
                        <div class="block--flex-inline flex--space-between">
                            <div class= "salepify-fg-advanced-main-section__offer-title text--bold">
                                ${conditionState === this.CONDITION_STATE.NOT_MET ? 
                                    this.handleReplaceVariable(rule, this.getOfferTitle(rule), remain, remainSpecific, totalGift) : 
                                    this.translation.main_offer.eligible_offer_title
                                }
                            </div>
                            
                            <div 
                                class="salepify-fg-advanced-main-section__view-offer-btn btn--plain" 
                                onclick='window.tlAdvancedFreeGift.handleViewMore("${ruleId}")'
                            >
                                ${i == 0 ? this.translation.main_offer.view_less : this.translation.main_offer.view_more}
                            </div>
                        </div>
                        
                        <div class="salepify-fg-advanced-offer block--flex-inline">
                            ${this.renderOffer(listParentDisplayIds)}
                        </div>

                        <div class="divider"></div>
                        
                        <div class="salepify-fg-advanced-customer-buy block--flex block--collapsible">
                            ${this.renderCustomerBuy(listParentDisplayIds, parentMapRequiredQty)}
                        </div>

                        <div class="salepify-fg-advanced-main-section__upsell-banner">
                            ${this.handleReplaceVariable(
                                rule, 
                                this.renderUpsellMsg(conditionState, rule.auto_add_gift), 
                                remain, 
                                remainSpecific, 
                                totalGift
                            )}
                        </div>

                        <div class="salepify-fg-advanced-gift-list block--flex block--collapsible">
                            ${this.renderGifts(
                                listChildDisplayIds, 
                                childMapRequiredQty, 
                                conditionState,
                                rule
                            )}

                        </div>
                      
                        <div class="salepify-fg-advanced-footer block--flex-inline flex--space-between block--collapsible"
                            style="display: ${(conditionState !== this.CONDITION_STATE.NOT_MET && !rule.auto_add_gift) ? "flex" : "none"}"
                        >
                            <div class="salepify-fg-advanced-footer__remain-gift-title">
                                ${this.translation.manual_choose_gift.selected_text} 
                                ${conditionState !== this.CONDITION_STATE.MET_AFFTER_CLAIM ?
                                    this.getTotalSelectedGift(ruleId) : totalGift
                                }/${totalGift}
                            </div>

                            ${
                                conditionState === this.CONDITION_STATE.MET_BEFORE_CLAIM ? 
                                    `<div class="salepify-fg-advanced-footer__claim-btn btn--fake" onclick='window.tlAdvancedFreeGift.handleAddGiftAndReload(${ruleId})'>
                                        ${this.translation.manual_choose_gift.claim_btn}
                                    </div>` :
                                    `<div class="salepify-fg-advanced-footer__claim-btn salepify-fg-advanced-footer__claim-btn--claimed">
                                        ${this.translation.manual_choose_gift.claimed_btn}
                                    </div> `
                            }
                        </div>
                        <div id="salepify-fg-advanced-error-${ruleId}">
                            <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512">
                                <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                            </svg>
                            <span class="salepify-fg-advanced-error__message"></span>
                        </div>
                    </div>
                `;

                if(conditionState == this.CONDITION_STATE.MET_BEFORE_CLAIM) availableToClaim ++;
            }else {
                needToReload = this.updateSelectedGifts(rule)
            }
        }

        if(listRuleNeedToAddGift.length){
            if(this.itemsInTempCart.size){
                listRuleNeedToAddGift.map((ruleId) => {
                    this.updateGiftsInTempCart(ruleId, true);
                })
            }else {
                const addCartReq = await this.handleAddGift(listRuleNeedToAddGift);
                if(addCartReq.status === 200){
                    this.showIconPopUpMessage("You’ve received a gift. Please reload to view the changes.", availableToClaim)
                    if(needToReload) {
                        if(!window.TLCustomEventGiftsAdvanced){
                            window.location.reload();
                        } else if (window.TLCustomEventGiftsAdvanced == 1) {
                            window.dispatchEvent(new CustomEvent("TLCustomEvent:FreeGiftsAdvanced-render-needToReload"));
                        }
                    };
                }else {
                    // Return error if there are not enough gift to add
                    const addCartRes = await addCartReq.json();
                    this.showIconPopUpMessage(addCartRes.description, 1)
                }
            }
        }else {
            if(availableToClaim){
                this.showIconPopUpMessage(this.translation.gift_icon.manual, availableToClaim);
            }else {
                this.iconPopupBadgeElement.style = "display: none";
            }
        }
        if(bodyHtml) {
            const popupIcon = document.querySelector(".salepify-fg-advanced-icon-popup__icon");
            
            popupIcon.style.display = this.displaySettings.icon_popup.is_icon_displayed ? "block" : "none";
            this.iconPopupElement.style.display = "flex";
            this.iconPopupElement.style.backgroundImage = this.displaySettings.icon_popup.is_icon_displayed ? "none" : `url(${this.displaySettings.icon_popup.adv_free_gift_image.url})`;
      
            bodyElement.innerHTML = bodyHtml;

            if(hasRuleMetCondition){
                this.openGiftModal();
            }
        }
        
        if(listRuleNeedToRemoveGift.length && !this.itemsInTempCart.size){
            await this.handleRemoveGift(listRuleNeedToRemoveGift);
            if(!window.TLCustomEventGiftsAdvanced){
                window.location.reload();
            } else if (window.TLCustomEventGiftsAdvanced == 1) {
                window.dispatchEvent(new CustomEvent("TLCustomEvent:FreeGiftsAdvanced-render-needToRemoveGift"));
            }
        }
    }

    reRender = async () => {
        const listRuleNeedToAddGift = [];
        const listRuleNeedToRemoveGift = [];

        let availableToClaim = 0;
        let needToReload = false;
        let hasRuleMetCondition = false;
        for (let i = 0; i < this.rules.length; i++) { 
            const rule = this.rules[i];
            const ruleId = rule.id;
            const [conditionState, claimedCount, canClaimCount, remain, remainSpecific] = this.getRemain(rule);
            
            if(claimedCount < canClaimCount) {
                rule.auto_add_gift ? listRuleNeedToAddGift.push(ruleId) : null;
            }else if(claimedCount > canClaimCount){
                rule.auto_remove_gift ? listRuleNeedToRemoveGift.push({
                    id: ruleId,
                    removeTime: claimedCount - canClaimCount
                }): null;
            }
            
            if(rule.show_free_gift_widget && this.checkShowOnPage(rule.show_on_pages)){
                if(claimedCount < canClaimCount && !rule.auto_add_gift) {
                    hasRuleMetCondition = true;
                }
                const totalGift = rule.gift_qty * this.ruleIdMapCanClaimTime.get(ruleId);
                const mainSectionElement = document.querySelector(`#salepify-fg-advanced-main-section-${ruleId}`);

                // Offer title
                let offerTitleInnerHTML = this.translation.main_offer.eligible_offer_title;

                if(conditionState === this.CONDITION_STATE.NOT_MET){
                    // Set state main section
                    mainSectionElement.classList.remove("salepify-fg-advanced-main-section--allow-claim", "salepify-fg-advanced-main-section--claimed");
                
                    offerTitleInnerHTML = this.handleReplaceVariable(rule, this.getOfferTitle(rule), remain, remainSpecific, totalGift);
                }else if(conditionState === this.CONDITION_STATE.MET_BEFORE_CLAIM){
                    // Set state main section
                    mainSectionElement.classList.remove("salepify-fg-advanced-main-section--claimed");
                    mainSectionElement.classList.add("salepify-fg-advanced-main-section--allow-claim")
                }else {
                    // Set state main section
                    mainSectionElement.classList.remove("salepify-fg-advanced-main-section--allow-claim");
                    mainSectionElement.classList.add("salepify-fg-advanced-main-section--claimed")
                }

                // Set innerHTML of offer_title
                mainSectionElement.querySelector(".salepify-fg-advanced-main-section__offer-title").innerHTML = offerTitleInnerHTML;

                // Set innerHTML of upsell_msg
                mainSectionElement.querySelector(".salepify-fg-advanced-main-section__upsell-banner").innerHTML = this.handleReplaceVariable(
                    rule, 
                    this.renderUpsellMsg(conditionState, rule.auto_add_gift), 
                    remain, 
                    remainSpecific, 
                    totalGift
                );

                // Footer elment
                const footerElment = mainSectionElement.querySelector(".salepify-fg-advanced-footer");
                if(!rule.auto_add_gift && conditionState !== this.CONDITION_STATE.NOT_MET){
                    //Set footer style
                    footerElment.innerHTML = `
                        <div class="salepify-fg-advanced-footer__remain-gift-title">
                            ${this.translation.manual_choose_gift.selected_text} 
                            ${conditionState !== this.CONDITION_STATE.MET_AFFTER_CLAIM ?
                                this.getTotalSelectedGift(ruleId) : totalGift
                            }/${totalGift}
                        </div>
                            
                        ${
                            conditionState === this.CONDITION_STATE.MET_BEFORE_CLAIM ? 
                                `<div class="salepify-fg-advanced-footer__claim-btn btn--fake" 
                                    onclick='${this.itemsInTempCart.size > 0 ? 
                                        `window.tlAdvancedFreeGift.handleAddGiftToTempCart(${ruleId})`  :
                                        `window.tlAdvancedFreeGift.handleAddGiftAndReload(${ruleId})` 
                                    }'
                                >
                                    ${this.translation.manual_choose_gift.claim_btn}
                                </div>` :
                                `<div class="salepify-fg-advanced-footer__claim-btn salepify-fg-advanced-footer__claim-btn--claimed">
                                    ${this.translation.manual_choose_gift.claimed_btn}
                                </div> `
                        }
                    `;
                    footerElment.style.display = "flex";
                }else {
                    footerElment.style.display = "none";
                }

                const listGiftElement = mainSectionElement.querySelectorAll(`div[id^="salepify-fg-advanced-gift-${ruleId}"]`);

                listGiftElement.forEach((element) => {
                    const checkBoxElement = element.querySelector(".salepify-fg-advanced-checkbox");
                    const imageElement = element.querySelector(".salepify-fg-advanced-gift-info__img");

                    if(conditionState === this.CONDITION_STATE.MET_BEFORE_CLAIM){
                        if(!rule.auto_add_gift){
                            //Set show checkbox
                            checkBoxElement.classList.remove("salepify-fg-advanced-checkbox--hide");
                            checkBoxElement.classList.add("salepify-fg-advanced-checkbox--show");
                        }

                        // Set image
                        imageElement.classList.remove("salepify-fg-advanced-gift-info__img--condition-not-met");
                        imageElement.querySelector("svg").style.display = "none";
                    
                    }else {
                        //Set hide checkbox
                        checkBoxElement.classList.remove("salepify-fg-advanced-checkbox--show");
                        checkBoxElement.classList.add("salepify-fg-advanced-checkbox--hide");
                        element.querySelector(".salepify-fg-advanced-gift-qty-selector").style.display = "none";

                        // Set image
                        if(conditionState === this.CONDITION_STATE.NOT_MET){
                            imageElement.classList.add("salepify-fg-advanced-gift-info__img--condition-not-met");
                            imageElement.querySelector("svg").style.display = "block";
                            checkBoxElement.querySelector(".salepify-fg-advanced-checkbox__inp-cbx").checked = false;
    
                            if(!rule.auto_add_gift){
                                this.ruleIdMapSelectedGift.set(ruleId, {}); 
                            }
                        }else {
                            imageElement.classList.remove("salepify-fg-advanced-gift-info__img--condition-not-met");
                            imageElement.querySelector("svg").style.display = "none";
                        }
                    }
                })

                if(conditionState == this.CONDITION_STATE.MET_BEFORE_CLAIM) availableToClaim ++;
                // Update gift selected with same buy option
                if(rule.gift_type == this.GIFT_TYPE.SAME_BUY){ 
                    this.updateSelectedGiftWithSameBuyOpt(rule);
                }
            }else {
                needToReload = this.updateSelectedGifts(rule);
            }
        }

        if(listRuleNeedToAddGift.length){
            if(this.itemsInTempCart.size){
                listRuleNeedToAddGift.map((ruleId) => {
                    this.updateGiftsInTempCart(ruleId, true);
                })
            }else {
                const addCartReq = await this.handleAddGift(listRuleNeedToAddGift);
                if(addCartReq.status === 200){
                    this.showIconPopUpMessage("You’ve received a gift. Please reload to view the changes.", availableToClaim);
                    if(needToReload) {
                        if(!window.TLCustomEventGiftsAdvanced){
                            window.location.reload();
                        } else if (window.TLCustomEventGiftsAdvanced == 1) {
                            window.dispatchEvent(new CustomEvent("TLCustomEvent:FreeGiftsAdvanced-reRender-needToReload"));
                        }
                    };
                }else {
                    // Return error if there are not enough gift to add
                    const addCartRes = await addCartReq.json();
                    this.showIconPopUpMessage(addCartRes.description, 1)
                }
            }
        }else {
            if(availableToClaim){
                this.showIconPopUpMessage(this.translation.gift_icon.manual, availableToClaim);
            }else {
                // this.iconPopupBadgeElement.style = "display: none";
            }
        }

        this.renderTempCart();
        if(hasRuleMetCondition){
            this.openGiftModal();
        }
        
        if(listRuleNeedToRemoveGift.length && !this.itemsInTempCart.size){
            await this.handleRemoveGift(listRuleNeedToRemoveGift);
            if(!window.TLCustomEventGiftsAdvanced){
                window.location.reload();
            } else if (window.TLCustomEventGiftsAdvanced == 1) {
                window.dispatchEvent(new CustomEvent("TLCustomEvent:FreeGiftsAdvanced-render-needToRemoveGift"));
            }
        }
    }

    openTempCart = () => {
        const tempCartElement = document.querySelector(".salepify-fg-advanced-temp-cart");

        tempCartElement.classList.remove("salepify-fg-advanced-temp-cart--hide")
        tempCartElement.classList.add("salepify-fg-advanced-temp-cart--show")
    }
    
    closeTempCart = () => {
        const tempCartElement = document.querySelector(".salepify-fg-advanced-temp-cart");

        tempCartElement.classList.remove("salepify-fg-advanced-temp-cart--show");
        tempCartElement.classList.add("salepify-fg-advanced-temp-cart--hide");
    }

    renderTempCart = () => {
        const tempCartBodyElement = document.querySelector(".salepify-fg-advanced-temp-cart-body");

        let itemHtml = ``;
        
        Array.from(this.itemsInTempCart).map(([itemId, item]) => {
            const itemData = this.shopifyIdMapData.get(itemId);

            itemHtml += `
                <div class="salepify-fg-advanced-temp-cart-item">
                    <div class="salepify-fg-advanced-temp-cart-item__img">
                        <img src="${itemData.image}" alt="${itemData.title}" />
                    </div>
                    <p class="salepify-fg-advanced-temp-cart-item__quantity">
                        ${item.quantity}
                    </p>
                    <div class="salepify-fg-advanced-temp-cart-item__remove-btn btn--fake" onclick='window.tlAdvancedFreeGift.handleRemoveFromTempCart("${itemId}")'>
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 13L13 1M1 1L13 13" stroke="#9CA3AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </div>
            `;
        })

        let giftHtml = ``;
        
        Array.from(this.giftsInTempCart).map(([giftId, item]) => {
            const giftData = this.shopifyIdMapData.get(giftId);

            giftHtml += `
                <div class="salepify-fg-advanced-temp-cart-gift">
                    <div class="salepify-fg-advanced-temp-cart-gift__img">
                        <img src="${giftData.image}" alt="${giftData.title}" />
                    </div>
                    <p class="salepify-fg-advanced-temp-cart-gift__quantity">
                        ${item.quantity}
                    </p>
                    ${
                        !item.isAutoAdd ? `
                        <div class="salepify-fg-advanced-temp-cart-gift__remove-btn btn--fake" onclick='window.tlAdvancedFreeGift.handleRemoveGiftFromTempCart("${giftId}")'>
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 13L13 1M1 1L13 13" stroke="#9CA3AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>`: ""
                    }
                    <div class="salepify-fg-advanced-temp-cart-gift__free-badge">${this.translation.product_detail.free_text_content}</div>
                </div>
            `;
        })
        const bodyHtml = giftHtml ? 
            `${itemHtml} 
                <svg viewBox="0 0 14 14" width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M7 0.5C7.55228 0.5 8 0.947715 8 1.5V6.5H13C13.5523 6.5 14 6.94772 14 7.5C14 8.05228 13.5523 8.5 13 8.5H8V13.5C8 14.0523 7.55228 14.5 7 14.5C6.44772 14.5 6 14.0523 6 13.5V8.5H1C0.447715 8.5 0 8.05228 0 7.5C0 6.94771 0.447715 6.5 1 6.5L6 6.5V1.5C6 0.947715 6.44772 0.5 7 0.5Z" fill="#111827"/>
                </svg>
                ${giftHtml}
            ` : itemHtml;

        tempCartBodyElement.innerHTML = bodyHtml;
        bodyHtml ? this.openTempCart() : this.closeTempCart();
    }

    createAjaxCartErrorResponse = (statusCode, errMessage) => {
        return new Promise((resolve, reject) => {
            const response = new Response(JSON.stringify({ 
                errors: errMessage,
                description: errMessage,
                message: errMessage,
                status: statusCode
            }), {
                status: statusCode,
                headers: {
                    "Content-Type": "application/json"
                }
            });
            resolve(response);
        });
    }
}

const tlAdvancedFreeGiftOverride = () => {
    if (!window || !window.Shopify) return;
    const CartEvents = {
        add: "TLADVANCEDFG:add",
        update: "TLADVANCEDFG:update",
        change: "TLADVANCEDFG:change",
        clear: "TLADVANCEDFG:clear",
        mutate: "TLADVANCEDFG:mutate",
    };
    const ShopifyCartURLs = [
        "/cart/add",
        "/cart/update",
        "/cart/change",
        "/cart/add.js",
        "/cart/update.js",
        "/cart/change.js",
        "/cart/clear.js",
        "/cart/add.js?upcart=1&opens_cart=maybe"
    ];

    function isShopifyCartURL(url) {
        if(typeof URL == "function" && url instanceof URL) url = url.href;
        if(typeof url == "object" && url.url) url = url.url;
        if (!url || url.includes("app=salepify") || url.includes("timestamp")) return false;

        try {
            let path = url.split("/").pop();
                path = path.split("?").shift();
            return ShopifyCartURLs.includes(`/cart/${path}`);
        } catch (e) {
            console.log("Not a normal URL: ", e)
            return false;
        }
    }

    function updateType(url) {
        if (!url || url.includes("app=salepify")) return false;
        if (url.includes("cart/add")) {
            return "add";
        } else if (url.includes("cart/update")) {
            return "update";
        } else if (url.includes("cart/change")) {
            return "change";
        } else if (url.includes("cart/clear")) {
            return "clear";
        } else return false;
    }

    function dispatchEvent(url, detail) {
        if (typeof detail === "string") {
            try {
                detail = JSON.parse(detail);
            } catch {
            }
        }
        window.dispatchEvent(new CustomEvent(CartEvents.mutate, {detail}));
        const type = updateType(url);
        switch (type) {
            case "add":
                window.dispatchEvent(new CustomEvent(CartEvents.add, {detail}));
                break;
            case "update":
                window.dispatchEvent(new CustomEvent(CartEvents.update, {detail}));
                break;
            case "change":
                window.dispatchEvent(new CustomEvent(CartEvents.change, {detail}));
                break;
            case "clear":
                window.dispatchEvent(new CustomEvent(CartEvents.clear, {detail}));
                break;
            default:
                break;
        }
    }

    function XHROverride() {
        if (!window.XMLHttpRequest) return;
        const originalOpen = window.XMLHttpRequest.prototype.open;
        window.XMLHttpRequest.prototype.open = function () {
            const url = arguments[1];
            this.addEventListener("load", function () {
                if (isShopifyCartURL(url)) {
                    dispatchEvent(url, this.response);
                }
            });
            return originalOpen.apply(this, arguments);
        };
    }

    function fetchOverride() {
        if (!window.fetch || typeof window.fetch !== "function") return;
        const originalFetch = window.fetch;
        window.fetch = async function () {
            let [resource, config] = [...arguments];
            if (isShopifyCartURL(resource) && config && config.body && config.body !== "{}") {
                const cartDataReq = await originalFetch('/cart.js', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                const cartDataRes = await cartDataReq.json();

                let itemId = null;
                let quantity = 1;
                let properties = {}
              
                // Check if this line is gift line
                let lineChangeIsGift = null;
                let isChangeCartLine = false;
                // Case: Add to cart
                if(resource.includes('add')){
                    // Body type is FormData
                    if(config.body instanceof FormData && config.body.getAll("id")){
                        itemId = String(config.body.getAll("id"));
                        quantity = Number(config.body.getAll("quantity")) ? Number(config.body.getAll("quantity")) : 1
                    }else {
                        // Body is a string 
                        const allRequestBody = config.body.split("&");
                        if (allRequestBody.length) {
                            allRequestBody.map(param => {
                                if (param) {
                                    const paramArray = param.split('=');
                                    if (paramArray.length > 1) {
                                        if (paramArray[0] === "id") {
                                            itemId = String(paramArray[1]);
                                        } else if (paramArray[0] === "quantity") {
                                            quantity = paramArray[1] ? Number(paramArray[1]) : 1;
                                        }
                                    } else if (window.tlAdvancedFreeGift.isJson(param)) {
                                        const paramObj = JSON.parse(param);
                                        if(paramObj.id){
                                            itemId = String(paramObj.id);
                                            quantity = paramObj.quantity ? Number(paramObj.quantity) : 1;
                                        }else if(paramObj.items){
                                            const item = paramObj.items[0];
                                            itemId = String(item.id);
                                            quantity = item.quantity ? Number(item.quantity) : 1;
                                        }
                                    }
                                }
                            })
                        }
                    }
                }else {
                    // Case: Change or Update cart
                    isChangeCartLine = true;
                    let items = JSON.parse(JSON.stringify(cartDataRes.items));
                    let lineChangeIndex = null;
                    const bodyArgument = JSON.parse(config.body);
                    let newLineQty = Number(bodyArgument.quantity);
                    if(bodyArgument.line){
                        lineChangeIndex = Number(bodyArgument.line) - 1;
                    }else if(bodyArgument.id){
                        items.map((item, index) => {
                            if(item.key === bodyArgument.id){
                                lineChangeIndex =  index;
                              properties = bodyArgument.properties ? bodyArgument.properties : {}
                            }
                        });
                    }else if(bodyArgument.updates) {
                        const updates = bodyArgument.updates;
                        items.map((item, index) => {
                            if(updates[item.key] === item.quantity !== Number(updates[item.key])){
                                lineChangeIndex =  index;
                                newLineQty = Number(updates[item.key])
                            }
                        });
                    }
                    // Fix for empire theme - With change.js APIs, it only updates the property without updating the line item.
                    // There is no id to find the line item, return the original fetch response.
                    if (lineChangeIndex === null) return originalFetch.apply(this, arguments);

                    const changeItem = items[lineChangeIndex];
                    
                    let ruleIdApplyToItem = null;
                    
                    // Get discount id base on discount applying
                    changeItem.discounts.find(discount => {
                        if (window.tlAdvancedFreeGift.discountCodeMapRuleId.get(discount.title)) {
                            ruleIdApplyToItem = window.tlAdvancedFreeGift.discountCodeMapRuleId.get(discount.title);
                            return true
                        }
                    })
                    if(!ruleIdApplyToItem) {
                        // Case: there is no discount apply => check base on property in line item
                        ruleIdApplyToItem = changeItem.properties[window.tlAdvancedFreeGift.PROPERTY]
                    }
                    if(ruleIdApplyToItem && changeItem.final_price == 0 && JSON.stringify(properties) == "{}"){
                        lineChangeIsGift = ruleIdApplyToItem
                        const ruleData = window.tlAdvancedFreeGift.ruleIdMapData.get(ruleIdApplyToItem);

                        if(ruleData && ruleData.prevent_change_gift_qty){
                            const errMessage = `You can't add more ${changeItem.quantity} ${changeItem.title} to the cart.`;
                            return window.tlAdvancedFreeGift.createAjaxCartErrorResponse(422, errMessage)
                        }
                    }
                    itemId = String(changeItem.key);
                    if(newLineQty > 0){
                        quantity = newLineQty - changeItem.quantity;
                    }else {
                        quantity = - changeItem.quantity;
                    }
                }

                // If the line change is a gift, it will update the quantity of gifts in the cart for calculation.
                if(lineChangeIsGift && quantity < 0){
                    const currentGiftQtyInCart = window.tlAdvancedFreeGift.ruleIdMapGiftQtyInCart.get(lineChangeIsGift);
                    if(currentGiftQtyInCart) {
                        window.tlAdvancedFreeGift.ruleIdMapGiftQtyInCart.set(lineChangeIsGift, currentGiftQtyInCart + quantity)
                    }
                }else {
                    let itemData = window.tlAdvancedFreeGift.itemsInCart.get(itemId);
                    if(itemData){
                        window.tlAdvancedFreeGift.itemsInCart.set(itemId, {
                            ...itemData,
                            quantity: itemData.quantity + quantity > 0 ? itemData.quantity + quantity : 0
                        })
                    }else {
                        itemData = await window.tlAdvancedFreeGift.getVariantData(itemId);
                        if(itemData){
                            const productId = itemData.product.id.split("/").pop();
                            window.tlAdvancedFreeGift.itemsInCart.set(itemId, {
                                id: itemId,
                                price: parseFloat(itemData.price.amount) * window.tlAdvancedFreeGift.currencyRate,
                                quantity: quantity ,
                                productId: productId,
                                collectionIds: window.tlAdvancedFreeGift.productIdMapCollection.get(productId)
                            })
                        }
                    }
                }

                const listRuleNeedToAddGift = [];
                const listRuleNeedToRemoveGift = [];
                window.tlAdvancedFreeGift.rules.map(rule => {
                    if(rule.auto_add_gift || rule.auto_remove_gift){
                        const ruleId = rule.id;
                        const [conditionState, claimedCount, canClaimCount] = window.tlAdvancedFreeGift.getRemain(rule);
            
                        if(claimedCount < canClaimCount) {
                            rule.auto_add_gift ? listRuleNeedToAddGift.push(ruleId) : null;
                        }else if(claimedCount > canClaimCount){
                            rule.auto_remove_gift ? listRuleNeedToRemoveGift.push({
                                id: ruleId,
                                removeTime: claimedCount - canClaimCount
                            }): null;
                        }
                        // Update gift selected with same buy option
                        if (rule.gift_type == window.tlAdvancedFreeGift.GIFT_TYPE.SAME_BUY) {
                            window.tlAdvancedFreeGift.updateSelectedGiftWithSameBuyOpt(rule);
                        }
                    }
                })

                let isAddOrRemove = false;
                //Add gift
                if(listRuleNeedToAddGift.length){
                    isAddOrRemove = true;
                    await window.tlAdvancedFreeGift.handleAddGift(listRuleNeedToAddGift);
                    window.tlAdvancedFreeGift.showIconPopUpMessage(
                        window.tlAdvancedFreeGift.translation.gift_icon.auto, 
                        listRuleNeedToAddGift.length
                    );
                } 

                //Remove gift
                if(listRuleNeedToRemoveGift.length){
                    isAddOrRemove = true;
                    await window.tlAdvancedFreeGift.handleRemoveGift(listRuleNeedToRemoveGift);

                    window.tlAdvancedFreeGift.iconPopupBadgeElement.style = "display: none";
                }

                // If fetch is change.js and removed or added gift  => Update line and quantity 
                if(isChangeCartLine && isAddOrRemove){
                    const cartDataReq = await originalFetch('/cart.js', {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    });
                    const cartDataRes = await cartDataReq.json();

                    const dataUpdate = {
                        line: 0,
                        quantity: 0
                    }

                    const itemIdPrefix = itemId.split(":").shift();
                    // Update the {{updates}} attribute – This is for stores that have the {{updates}} attribute in cart/update.js
                    const updates = {};

                    cartDataRes.items.map((item, index) => {
                        const giftProperty = item.properties[window.tlAdvancedFreeGift.PROPERTY];
                        // Map the key of {{updates}} to the corresponding quantity
                        updates[item.key] = String(item.quantity);
                        if(
                            item.key == itemId ||
                            (item.id == itemIdPrefix && !giftProperty)
                        ){
                            dataUpdate.line = String(index + 1);
                            dataUpdate.quantity = String(item.quantity + quantity);
                            // Map the key of {{updates}} to the corresponding quantity
                            updates[item.key] = String(item.quantity + quantity);
                        }
                    })
                    const bodyArgument = JSON.parse(config.body);

                    arguments[1].body = JSON.stringify({
                        ...bodyArgument,
                        updates: bodyArgument.updates ? updates : undefined,
                        ...dataUpdate
                    })
                }

                const response = originalFetch.apply(this, arguments);

                response.then((res) => {
                    res
                        .clone()
                        .json()
                        .then((data) => dispatchEvent(res.url, data));
                });
                return response;
            } else {
                return originalFetch.apply(this, arguments);
            }
        };
    }

    window.addEventListener('TLADVANCEDFG:add', () => {
        window.tlAdvancedFreeGift.updateCartData()
    })

    window.addEventListener('TLADVANCEDFG:change', () => {
        window.tlAdvancedFreeGift.updateCartData()
    })

    window.addEventListener('TLADVANCEDFG:update', () => {
        window.tlAdvancedFreeGift.updateCartData()
    })

    fetchOverride();
    XHROverride();
};

window.tlAdvancedFreeGift =  window.tlAdvancedFreeGift || new tlAdvancedFreeGift(
    tlAdvancedFGTemplate,
    tlAdvancedFGCurrencySymbol, 
    tlAdvancedFGDefaultImage,
    tlAdvancedFGOfferImage,
    tlAdvancedFGUpdateState,
    tlAdvancedFGDisplaySetting,
    tlAdvancedFGProductId,
    tlAdvancedFGCollectionsOfProduct,
    tlAdvancedFGProductIdMapCollection,
    tlAdvancedFGProductVariantIds,
    tlAdvancedFGCustomer,
    tlAdvancedFGTranslation
);